import { jsx as e, jsxs as p, Fragment as Q } from "react/jsx-runtime";
import { withManagedProps as P } from "@made-people/managed-props";
import { z as t } from "zod";
import { withZod as S } from "@made-people/react-prop-guard";
import G, { useEffect as U, useState as $, isValidElement as Yt, useRef as Ee, useCallback as Ge, useMemo as Xt } from "react";
import { p as Qt, a as Zt, b as q, c as qt, s as Jt, d as ea, e as ta, f as aa, g as na, h as oa, i as sa, j as ia, k as ra, l as la, m as ca, n as da, o as ua, q as pa, r as ma, t as ha, u as ba, v as Ce, w as ga, x as fa, y as va, z as ya, A as Pa, B as Sa, C as wa, D as _a, E as ka, F as Na, G as Ta, H as Ca, I as Aa, J as ge } from "./blueprint-572e03d6.mjs";
import { Drawer as j } from "@made-people/blueprint-drawer";
import * as le from "@radix-ui/react-dialog";
import { useOverlayState as Ba, overlayEventEmitter as ce } from "@made-people/blueprint-overlay";
import { useProductBase as W, ProductLink as ye, useProductAttributeGetter as ee, useProductPriceInfo as Pe, useProductDataModel as Z, useBundlePurchaseInfo as Ae, useProductImages as Da, useMediaAttributeGetter as Oe, useRelatedProducts as Be, ProductProvider as je, filterMediaOnAttributeValues as et, useProductSpecificationGroup as Ia, useProductAttribute as K, useProductPurchaseStatus as De, useProductOptions as Me, useProductSiblings as tt, useBundleOptions as Ke, useBundleItemId as La, useBundlePurchaseStatus as za, useProductHasOptionsInStock as xa } from "@made-people/grease-product";
import { useTranslate as I } from "@made-people/grease-translations";
import Ra from "clsx";
import { accordionItemSchema as Ea, accordionSchema as Ga, Accordion as Wa } from "@made-people/blueprint-accordion";
import { useKeenSlider as Ze } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { ResponsiveImage as te, responsiveImageSchema as at } from "@made-people/blueprint-responsive-image";
import { useBreakpointVisibility as Oa } from "@made-people/blueprint-ui-hooks";
import { responsiveVideoSchema as ja, ResponsiveVideo as nt } from "@made-people/blueprint-responsive-video";
import { MIX_AND_MATCH_IMAGE_ATTRIBUTE_KEY as ot } from "@made-people/blueprint-mix-and-match";
import { badgeSchema as st, Badge as He } from "@made-people/blueprint-badge";
import { CartEventAdditionalDataProvider as Ma, useUpdateCart as Ie, useCartMethod as Ka } from "@made-people/grease-cart";
import { uiEventEmitter as Ha } from "@made-people/grease-ui-events";
import { Heading as Va } from "@made-people/blueprint-heading";
import { isNotUndefined as Ua } from "@made-people/typeguards-common";
import { motion as J, AnimatePresence as de, cubicBezier as it } from "motion/react";
import { linkAsLinkSchema as $a, Link as Fa, LinkAsLink as Ya, linkAsButtonSchema as Xa, LinkAsButton as Qa } from "@made-people/blueprint-link";
import { buttonContentPropsSchema as ue, ButtonAsButton as fe, Button as oe, buttonAsButtonSchema as We, ButtonAsSpan as rt, buttonAsSpanSchema as Za } from "@made-people/blueprint-button";
import { toast as qa } from "sonner";
import { productCardSchema as Ja, ProductCard as en } from "@made-people/blueprint-product-card";
import { SearchResultProvider as lt, useSearchResultItems as tn } from "@made-people/grease-search";
import { swipeableProductListSchema as ct, SwipeableProductList as an } from "@made-people/blueprint-swipeable-product-list";
import { Markdown as nn } from "@made-people/blueprint-markdown";
import { GridContext as on } from "@made-people/blueprint-grid";
import { Breadcrumbs as se, breadcrumbsSchema as sn } from "@made-people/blueprint-breadcrumbs";
import { shippingBarometerSchema as rn, ShippingBarometer as ln } from "@made-people/blueprint-shipping-barometer";
import { NotifyMe as dt } from "@made-people/blueprint-notify-me";
import { StatusInformationIcon as cn } from "@made-people/blueprint-icons";
import { useLink as dn } from "@made-people/grease-link";
import "@made-people/blueprint";
const un = () => /* @__PURE__ */ e(
  "svg",
  {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12.9 12.9",
    children: /* @__PURE__ */ e("path", { d: "M7.5,6.5L12.7,1.3c.3-.3.3-.8,0-1.1s-.8-.3-1.1,0l-5.2,5.2L1.3.2C1,0,.5,0,.2.2s-.2.3-.2.5,0,.4.2.5l5.2,5.2L.2,11.6c-.3.3-.3.8,0,1.1s.3.2.5.2.4,0,.5-.2l5.2-5.2,5.2,5.2c.1.1.3.2.5.2s.4,0,.5-.2.2-.3.2-.5,0-.4-.2-.5l-5.2-5.2Z" })
  }
), pn = ({
  children: a,
  CloseIcon: o,
  slots: n
}) => {
  const { isOpen: s, onChange: i } = Ba();
  return U(() => {
    i(!0);
  }, []), /* @__PURE__ */ e(le.Root, { defaultOpen: !0, onOpenChange: i, open: s, children: /* @__PURE__ */ p(le.Portal, { children: [
    /* @__PURE__ */ e(le.Overlay, { className: n.modalOverlay }),
    /* @__PURE__ */ p(
      le.Content,
      {
        "aria-description": "Product Page Modal",
        "aria-describedby": "Product",
        className: n.modalContent,
        children: [
          /* @__PURE__ */ e(le.Title, { hidden: !0, children: "Product Page" }),
          /* @__PURE__ */ e(le.Close, { className: n.closeButton, children: o }),
          /* @__PURE__ */ e("section", { className: n.contentWrapper, children: a })
        ]
      }
    )
  ] }) });
}, ut = t.object({
  template: t.literal("drawer"),
  variants: t.custom().optional(),
  children: t.custom(() => !0).optional(),
  drawerSettings: t.custom().optional(),
  closeIcon: t.union([
    t.string(),
    t.custom(),
    t.custom()
  ]).optional()
}), mn = P(
  "ProductDrawer",
  S(
    ut,
    ({ variants: a, children: o, closeIcon: n = un, drawerSettings: s }) => {
      const i = Qt.styles(a), [c, r] = $(!1);
      U(() => {
        r(window.innerWidth > 1124);
      }, []);
      const l = () => typeof n == "string" || Yt(n) ? n : typeof n == "function" ? /* @__PURE__ */ e(n, {}) : null;
      return c ? /* @__PURE__ */ e(pn, { CloseIcon: l(), slots: i, children: o }) : /* @__PURE__ */ e(
        j,
        {
          ...s,
          defaultOpen: !0,
          direction: "bottom",
          variants: {
            dimmed: "subtle",
            blurred: "subtle",
            background: "none",
            ...s == null ? void 0 : s.variants
          },
          children: /* @__PURE__ */ p(
            j.Content,
            {
              contentSettings: {
                "aria-description": "Content for product popup",
                "aria-describedby": "Product"
              },
              children: [
                /* @__PURE__ */ e(j.Close, { className: i.closeButton, children: l() }),
                /* @__PURE__ */ e(j.Title, { hidden: !0, children: "Product Page popup" }),
                /* @__PURE__ */ e("div", { className: i.drawerWrapper, children: /* @__PURE__ */ e("section", { className: i.contentWrapper, children: o }) })
              ]
            }
          )
        }
      );
    }
  )
), pt = t.object({
  template: t.literal("grid"),
  variants: t.custom().optional(),
  children: t.custom(() => !0).optional()
}), hn = P(
  "ProductGrid",
  S(pt, ({ variants: a, children: o }) => {
    const n = Zt.styles(a);
    return /* @__PURE__ */ e("section", { className: n.base, children: o });
  })
), bn = t.discriminatedUnion("template", [
  ut,
  pt
]), gn = P(
  "ProductRoot",
  S(bn, (a) => a.template === "drawer" ? /* @__PURE__ */ e(mn, { ...a }) : a.template === "grid" ? /* @__PURE__ */ e(hn, { ...a }) : null)
), mt = t.object({
  variants: t.custom().optional(),
  text: t.string().optional(),
  blueprint: t.custom().optional(),
  headingTag: t.enum(["h1", "h2", "h3", "h4", "h5", "h6"]).optional(),
  asLink: t.boolean().optional()
}), fn = P(
  "ProductDetailsName",
  S(
    {
      schema: mt,
      defaultProps: {
        headingTag: "h1"
      }
    },
    ({ variants: a, text: o, headingTag: n, asLink: s, ...i }) => {
      const c = W(), {
        content: { name: r }
      } = c, u = (i.blueprint ?? q.main).styles(a), h = n ?? "h1", g = o ?? r;
      return s ? /* @__PURE__ */ e(h, { className: u.name, children: /* @__PURE__ */ e(ye, { productBase: c, context: "product-card", children: g }) }) : /* @__PURE__ */ e(h, { className: u.name, children: g });
    }
  )
), vn = t.object({
  variants: t.custom().optional()
}), yn = P(
  "ProductDetailsShortDescription",
  S(vn, ({ variants: a }) => {
    const {
      content: { shortDescription: o }
    } = W(), n = q.main.styles(a);
    return o ? /* @__PURE__ */ e("p", { className: n.shortDescription, children: o }) : null;
  })
), Ve = t.object({
  variants: t.custom().optional(),
  text: t.string().optional(),
  readMoreSettings: t.object({
    enabled: t.boolean(),
    limit: t.number().optional()
  }).optional(),
  label: t.string().optional(),
  blueprint: t.custom().optional(),
  formatDotsToList: t.boolean().optional()
}), Pn = P(
  "ProductDetailsDescription",
  S(
    Ve,
    ({
      variants: a,
      readMoreSettings: o,
      text: n,
      label: s,
      formatDotsToList: i,
      ...c
    }) => {
      const {
        content: { description: r }
      } = W(), u = (c.blueprint ?? q.main).styles(a), [h, g] = $(!(o != null && o.enabled)), v = I();
      if (!r && !n)
        return null;
      const _ = n ?? r, w = _.length > ((o == null ? void 0 : o.limit) ?? 200), b = i ? _.split(`
`).map((y) => {
        const f = y.trim();
        return f.startsWith("•") ? `<li>${f.substring(1).trim()}</li>` : f ? `${f}` : "";
      }).join("") : _;
      return /* @__PURE__ */ p("div", { className: u.description, children: [
        s && /* @__PURE__ */ e("h2", { className: u.descriptionLabel, children: s }),
        /* @__PURE__ */ e(
          "p",
          {
            className: h ? "" : "line-clamp-2",
            dangerouslySetInnerHTML: {
              __html: h ? b : `${b.substring(0, 200)}...`
            }
          }
        ),
        (o == null ? void 0 : o.enabled) && w && /* @__PURE__ */ e(
          "button",
          {
            className: u.descriptionReadMoreButton,
            onClick: () => g(!h),
            children: v(h ? "Product_Description_Read_Less" : "Product_Description_Read_More")
          }
        )
      ] });
    }
  )
), Sn = t.object({
  variants: t.custom().optional()
}), wn = P(
  "ProductDetailsBrand",
  S(Sn, ({ variants: a }) => {
    var c;
    const o = W(), n = q.main.styles(a), i = (c = ee(o)("brandName", t.string())) == null ? void 0 : c.value;
    return i ? /* @__PURE__ */ e("span", { className: n.brand, children: i }) : null;
  })
), ht = t.object({
  drawerSettings: t.custom().optional(),
  trigger: t.custom().optional(),
  isEnabled: t.boolean().optional()
}), _n = 1024, kn = P(
  "PriceHistoryDrawer",
  S(ht, (a) => {
    var h, g;
    const o = qt.styles(), n = Pe(), [s, i] = $(!1), c = I(), r = (h = n.previouslyDiscountedPrices) == null ? void 0 : h.find(
      (v) => v.periodDays === 30
    ), l = n.price.formatted !== (r == null ? void 0 : r.price.formatted);
    if (U(() => {
      const v = () => {
        i(window.innerWidth > _n);
      };
      return window.addEventListener("resize", v), v(), () => {
        window.removeEventListener("resize", v);
      };
    }, []), !a.isEnabled)
      return null;
    const u = (g = n.discountInfo) != null && g.percent ? `(-${n.discountInfo.percent}%)` : "";
    return /* @__PURE__ */ p(
      j,
      {
        customOverlayId: "price-history",
        hasOverlay: !0,
        hasScaledBackground: !0,
        setBackgroundColorOnScale: !1,
        header: {
          headingSettings: {
            heading: c("Price_History_Heading")
          }
        },
        hasHandle: !s,
        variants: {
          dragHandle: s ? "false" : "true",
          rounded: s ? "none" : "strong",
          background: "white",
          direction: s ? "right" : "bottom"
        },
        direction: s ? "right" : "bottom",
        ...a.drawerSettings,
        children: [
          l && /* @__PURE__ */ p(j.Trigger, { className: o.trigger, children: [
            /* @__PURE__ */ e(
              "span",
              {
                className: "absolute w-10 h-10",
                tabIndex: -1,
                "aria-hidden": "true"
              }
            ),
            a.trigger
          ] }),
          /* @__PURE__ */ e(j.Content, { children: /* @__PURE__ */ p("div", { className: o.contentWrapper, children: [
            /* @__PURE__ */ p("div", { className: o.priceRow, children: [
              /* @__PURE__ */ e("span", { className: o.priceValue, children: n.price.formatted }),
              u && /* @__PURE__ */ e("span", { className: o.discountBadge, children: c("Price_History_Current_Price", {
                discountPercent: u
              }) })
            ] }),
            r && /* @__PURE__ */ p("div", { className: o.priceRow, children: [
              /* @__PURE__ */ e("span", { className: o.priceValue, children: r.price.formatted }),
              /* @__PURE__ */ e("span", { className: o.priceLabel, children: c("Price_History_Lowest_Price_In_Last_30_Days") })
            ] }),
            /* @__PURE__ */ p("div", { className: o.priceRow, children: [
              /* @__PURE__ */ e("span", { className: o.priceValue, children: n.priceWithoutDiscount.formatted }),
              /* @__PURE__ */ e("span", { className: o.priceLabel, children: c("Price_History_Original_Price") })
            ] })
          ] }) })
        ]
      }
    );
  })
), bt = t.object({
  variants: t.custom().optional(),
  blueprint: t.custom().optional(),
  priceHistoryDrawerSettings: ht.optional()
}), Nn = P(
  "ProductDetailsPrice",
  S(bt, ({ variants: a, ...o }) => {
    const n = Pe(), i = (o.blueprint ?? q.main).styles(a), c = Z(), r = n.price.number < n.priceWithoutDiscount.number;
    return /* @__PURE__ */ e(Q, { children: /* @__PURE__ */ p("div", { className: i.priceWrapper, children: [
      /* @__PURE__ */ e(
        "span",
        {
          "data-is-discounted": r ? "true" : "false",
          className: i.price,
          children: n.price.formatted
        }
      ),
      r && /* @__PURE__ */ p("span", { className: i.oldPrice, children: [
        n.priceWithoutDiscount.formatted,
        /* @__PURE__ */ e(
          m.PriceHistoryDrawer,
          {
            ...o.priceHistoryDrawerSettings
          }
        )
      ] }),
      c === "bundle" && /* @__PURE__ */ e(Tn, {})
    ] }) });
  })
), Tn = () => (Ae(), null), Cn = t.object({
  variants: t.custom().optional(),
  children: t.custom().optional()
}), An = P(
  "ProductDetailsWrapper",
  S(Cn, ({ variants: a, children: o }) => {
    const n = q.main.styles(a);
    return /* @__PURE__ */ e("section", { className: n.wrapper, children: o });
  })
), pe = t.object({
  variants: t.custom().optional(),
  attributeKey: t.string().optional(),
  className: t.string().optional(),
  label: t.string().optional()
}), Bn = P(
  "ProductDetailsProductType",
  S(
    {
      schema: pe,
      defaultProps: {
        attributeKey: "subHeadline"
      }
    },
    ({ variants: a, attributeKey: o, className: n, label: s }) => {
      var u;
      const i = W(), r = (u = ee(i)(
        o ?? "",
        t.string()
      )) == null ? void 0 : u.value, l = q.main.styles(a);
      if (!(!r && !s))
        return /* @__PURE__ */ e("span", { className: Ra(l.productType, n), children: s ?? r });
    }
  )
), Ue = Ea.extend({
  content: t.object({
    value: t.string().optional(),
    attributeKey: t.string().optional(),
    trigger: t.custom().optional(),
    content: t.custom().optional(),
    forceMount: t.boolean().optional()
  })
}), Dn = t.object({
  variants: t.custom().optional(),
  items: t.array(Ue).optional(),
  settings: Ga.omit({ items: !0 }).optional()
}), In = P(
  "ProductDetailsAccordion",
  S(Dn, ({ variants: a, items: o, settings: n }) => {
    const s = W(), i = ee(s), c = q.main.styles(a), r = o == null ? void 0 : o.map((l) => {
      var h;
      let u = l.content.content;
      if (l.content.attributeKey) {
        const g = (h = i(
          l.content.attributeKey,
          t.string()
        )) == null ? void 0 : h.value;
        if (!u && !g)
          return null;
        u = g ?? u;
      }
      return u ? {
        ...l,
        content: {
          content: u,
          value: l.content.value,
          trigger: l.content.trigger,
          forceMount: l.content.forceMount
        }
      } : null;
    }).filter((l) => l !== null);
    return r ? /* @__PURE__ */ e("div", { className: c.accordionWrapper, children: /* @__PURE__ */ e(
      Wa,
      {
        ...n,
        blueprint: q.accordion,
        layout: {
          spacing: {
            applySpacing: "false"
          },
          position: {
            applyPosition: "false"
          }
        },
        items: r
      }
    ) }) : null;
  })
), Ln = {
  Name: fn,
  ShortDescription: yn,
  Brand: wn,
  Price: Nn,
  Wrapper: An,
  Description: Pn,
  ProductType: Bn,
  Accordion: In
  // Add other components as needed
}, zn = t.object({
  className: t.string().optional(),
  badgeSettings: st.optional(),
  hide: t.boolean().optional()
}), xn = ({
  badgeSettings: a,
  hide: o,
  className: n
}) => {
  const s = I(), i = Ae(), c = i.discountFromPriceOfItemsOutsideBundle.formatted, r = i.discountFromPriceOfItemsOutsideBundle.number;
  return o || !c || r <= 0 ? null : /* @__PURE__ */ e("div", { className: n, children: /* @__PURE__ */ e(
    He,
    {
      ...a,
      label: s("PDP_Bundle_Savings_Badge", { bundleSavings: c })
    }
  ) });
}, gt = P(
  "BundleSavingsBadge",
  S(zn, (a) => Z() !== "bundle" ? null : /* @__PURE__ */ e(xn, { ...a }))
), Rn = t.object({
  subHeadlineAttribute: t.string().optional(),
  variants: t.custom().optional()
}), En = P(
  "ShopTheLookItem",
  S(
    {
      schema: Rn,
      defaultProps: {
        subHeadlineAttribute: "subHeadline"
      }
    },
    ({ subHeadlineAttribute: a, variants: o }) => {
      var v;
      const n = W(), s = Da(), i = Pe(), c = Z(), r = ee(n), l = Jt.styles(o), u = s == null ? void 0 : s[0], h = i.price.number < i.priceWithoutDiscount.number, g = a ? (v = r(a, t.string())) == null ? void 0 : v.value : void 0;
      return /* @__PURE__ */ p("div", { className: l.wrapper, children: [
        /* @__PURE__ */ p("div", { className: l.contentWrapper, children: [
          u && /* @__PURE__ */ e(
            ye,
            {
              productBase: n,
              context: "product-card",
              className: l.imageWrapper,
              children: /* @__PURE__ */ e(te, { className: l.image, image: u })
            }
          ),
          /* @__PURE__ */ p("div", { className: l.info, children: [
            /* @__PURE__ */ e("h4", { className: l.productName, children: n.content.name }),
            g && /* @__PURE__ */ e("p", { className: l.productType, children: g }),
            /* @__PURE__ */ p("div", { className: l.priceWrapper, children: [
              /* @__PURE__ */ e(
                "span",
                {
                  "data-is-discounted": h ? "true" : "false",
                  className: l.price,
                  children: i.price.formatted
                }
              ),
              h && /* @__PURE__ */ e("span", { className: l.priceBeforeDiscount, children: i.priceWithoutDiscount.formatted })
            ] })
          ] })
        ] }),
        c === "with_variants" && /* @__PURE__ */ e(m.SizePicker, { template: "button-grid" }),
        /* @__PURE__ */ e(
          m.AddToCart,
          {
            template: "button",
            postAddAction: "none",
            buttonSettings: {
              variants: {
                width: "full"
              }
            }
          }
        )
      ] });
    }
  )
), $e = "shop_the_look", Gn = t.object({
  media: t.custom().optional(),
  className: t.string().optional(),
  variants: t.custom().optional(),
  drawerSettings: t.custom().optional(),
  closeIcon: t.custom().optional(),
  triggerIcon: t.custom().optional(),
  showProductCountAsSuffix: t.boolean().optional()
}), Wn = () => {
  const [a, o] = $(
    typeof window < "u" ? window.innerWidth > 1024 : !1
  );
  return U(() => {
    const n = () => {
      o(window.innerWidth > 1024);
    };
    return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), a;
}, ft = P(
  "ShopTheLook",
  S(
    {
      schema: Gn,
      defaultProps: {}
    },
    ({
      media: a,
      className: o = "",
      variants: n,
      drawerSettings: s,
      closeIcon: i,
      triggerIcon: c,
      showProductCountAsSuffix: r
    }) => {
      const [l, u] = $(!1), h = Wn(), g = Oe(
        a || {
          type: "image",
          src: "",
          alt: ""
        }
      ), v = (a == null ? void 0 : a.type) === "image" && g($e, t.boolean()), _ = ea.styles(n), w = Be("look"), b = I();
      if (!v || v.value !== !0 || !w.length)
        return null;
      const y = () => {
        Ha.emit("featureInteraction", {
          feature: "shop_the_look",
          action: "clicked"
        });
      };
      return /* @__PURE__ */ p(
        j,
        {
          open: l,
          onOpenChange: u,
          direction: h ? "right" : "bottom",
          variants: {
            rounded: "subtle"
          },
          ...s,
          children: [
            /* @__PURE__ */ e(
              j.Trigger,
              {
                className: o || _.trigger,
                onClick: y,
                "aria-label": `Shop The Look - ${w.length} ${w.length === 1 ? "product" : "products"}`,
                children: /* @__PURE__ */ p("div", { className: _.triggerContent, children: [
                  b("Shop_The_Look_Trigger"),
                  c
                ] })
              }
            ),
            /* @__PURE__ */ p(j.Content, { children: [
              /* @__PURE__ */ e(j.Title, { hidden: !0, children: b("Shop_The_Look_Heading") }),
              /* @__PURE__ */ p("div", { className: _.wrapper, children: [
                /* @__PURE__ */ p("div", { className: _.header, children: [
                  /* @__PURE__ */ e(
                    Va,
                    {
                      heading: b("Shop_The_Look_Heading"),
                      suffix: r ? String(w.length) : void 0,
                      variants: { headingSize: "lg" }
                    }
                  ),
                  /* @__PURE__ */ e(j.Close, { className: _.close, children: i ?? b("Shop_The_Look_Close") })
                ] }),
                /* @__PURE__ */ e("div", { className: _.productList, children: w.map((f, L) => /* @__PURE__ */ e(
                  Ma,
                  {
                    additionalData: {
                      source: "shop-the-look",
                      item_list_id: "shop-the-look",
                      item_list_name: "Shop The Look"
                    },
                    children: /* @__PURE__ */ e(
                      je,
                      {
                        product: f.product,
                        context: {
                          type: "plp",
                          listId: "shop-the-look",
                          listName: "Shop The Look",
                          position: L
                        },
                        children: /* @__PURE__ */ e(En, {})
                      }
                    )
                  },
                  f.product.base.productId
                )) })
              ] })
            ] })
          ]
        }
      );
    }
  )
), vt = {
  mobile: "150vw",
  tablet: "150vw",
  desktop: "100vw"
}, qe = 60, On = 300, jn = 30, Mn = 10, Kn = 500, Re = (a, o, n) => Math.max(o, Math.min(n, a)), Je = (a, o) => Math.hypot(a.clientX - o.clientX, a.clientY - o.clientY);
function yt({
  enabled: a = !1,
  maxScale: o = 2.5,
  onZoomChange: n,
  onSwipeAtEdge: s,
  hideCursor: i = !1,
  resetOnMouseLeave: c = !1
} = {}) {
  const [r, l] = G.useState(
    null
  ), u = G.useRef(null), h = G.useRef(null), [g, v] = G.useState(!1), [_, w] = G.useState(!1), [b, y] = G.useState(!1), f = G.useRef({ onZoomChange: n, onSwipeAtEdge: s });
  f.current = { onZoomChange: n, onSwipeAtEdge: s };
  const L = G.useRef({
    scale: 1,
    tx: 0,
    ty: 0,
    gesture: { type: "idle" },
    rect: null,
    pinchAnchor: null,
    zoomedFlag: !1,
    lastTapAt: 0,
    lastTapX: 0,
    lastTapY: 0,
    lastTouchEndAt: 0,
    tapStartX: 0,
    tapStartY: 0
  }), T = G.useCallback(() => {
    var R, O;
    const d = L.current;
    d.gesture = { type: "idle" }, d.scale = 1, d.tx = 0, d.ty = 0;
    const z = u.current;
    z && (z.style.transition = "transform 250ms", z.style.transform = "translate(0px, 0px) scale(1)"), d.zoomedFlag && (d.zoomedFlag = !1, v(!1), (O = (R = f.current).onZoomChange) == null || O.call(R, !1));
  }, []);
  G.useEffect(() => {
    if (!a || !r)
      return;
    const d = L.current, z = () => {
      d.rect = r.getBoundingClientRect();
    }, R = (k) => {
      const B = u.current;
      B && (d.rect && (d.tx = Re(d.tx, d.rect.width * (1 - d.scale), 0), d.ty = Re(d.ty, d.rect.height * (1 - d.scale), 0)), B.style.transition = k ? "transform 250ms" : "none", B.style.transform = `translate(${d.tx}px, ${d.ty}px) scale(${d.scale})`);
    }, O = (k) => {
      var B, N;
      d.zoomedFlag !== k && (d.zoomedFlag = k, k && w(!0), v(k), (N = (B = f.current).onZoomChange) == null || N.call(B, k));
    }, F = (k, B, N, M) => {
      if (!d.rect)
        return;
      const ne = k - d.rect.left, re = B - d.rect.top;
      d.scale = N, d.tx = -ne * (N - 1), d.ty = -re * (N - 1), R(M);
    }, Y = (k, B) => {
      const N = h.current;
      !N || !d.rect || (N.style.transform = `translate(${k - d.rect.left}px, ${B - d.rect.top}px) translate(-50%, -50%)`);
    };
    z();
    const V = (k) => {
      z();
      const B = d.rect;
      if (!B)
        return;
      const N = k.touches[0], M = k.touches[1];
      k.touches.length === 2 && N && M ? (k.preventDefault(), k.stopPropagation(), d.pinchAnchor || (d.pinchAnchor = { scale: d.scale, tx: d.tx, ty: d.ty }), d.gesture = {
        type: "pinch",
        startDist: Je(N, M),
        startScale: d.scale,
        startTx: d.tx,
        startTy: d.ty,
        anchorX: (N.clientX + M.clientX) / 2 - B.left,
        anchorY: (N.clientY + M.clientY) / 2 - B.top
      }) : k.touches.length === 1 && N && d.scale > 1 ? (k.preventDefault(), k.stopPropagation(), d.gesture = {
        type: "pan",
        startX: N.clientX,
        startY: N.clientY,
        startTx: d.tx,
        startTy: d.ty
      }, d.tapStartX = N.clientX, d.tapStartY = N.clientY) : (d.gesture = { type: "idle" }, N && (d.tapStartX = N.clientX, d.tapStartY = N.clientY));
    }, C = (k) => {
      var ne, re, ke, Qe;
      const B = d.gesture;
      if (B.type === "idle")
        return;
      k.preventDefault(), k.stopPropagation();
      const N = k.touches[0], M = k.touches[1];
      if (B.type === "pinch" && N && M && B.startDist > 0) {
        const be = Je(N, M) / B.startDist, Ne = Re(B.startScale * be, 1, o), Te = Ne / B.startScale;
        d.scale = Ne, d.tx = B.anchorX - (B.anchorX - B.startTx) * Te, d.ty = B.anchorY - (B.anchorY - B.startTy) * Te, R(!1);
      } else if (B.type === "pan" && N) {
        const be = B.startTx + (N.clientX - B.startX), Ne = B.startTy + (N.clientY - B.startY);
        if (d.tx = be, d.ty = Ne, R(!1), d.rect && d.scale > 1) {
          const Te = d.rect.width * (1 - d.scale);
          if (be > qe) {
            (re = (ne = f.current).onSwipeAtEdge) == null || re.call(ne, "prev"), T();
            return;
          }
          if (be < Te - qe) {
            (Qe = (ke = f.current).onSwipeAtEdge) == null || Qe.call(ke, "next"), T();
            return;
          }
        }
      }
    }, D = (k) => {
      const B = d.gesture;
      if (k.touches.length === 0) {
        if (d.lastTouchEndAt = Date.now(), d.pinchAnchor) {
          const M = d.pinchAnchor;
          d.pinchAnchor = null, d.gesture = { type: "idle" }, d.scale = M.scale, d.tx = M.tx, d.ty = M.ty, R(!0), O(M.scale > 1);
          return;
        }
        const N = k.changedTouches[0];
        if (N && (B.type === "pan" || B.type === "idle") && Math.hypot(
          N.clientX - d.tapStartX,
          N.clientY - d.tapStartY
        ) < Mn) {
          const ne = Date.now(), re = ne - d.lastTapAt, ke = Math.hypot(
            N.clientX - d.lastTapX,
            N.clientY - d.lastTapY
          );
          re < On && ke < jn ? (d.lastTapAt = 0, d.scale > 1 ? T() : (F(N.clientX, N.clientY, o, !0), O(!0))) : (d.lastTapAt = ne, d.lastTapX = N.clientX, d.lastTapY = N.clientY), d.gesture = { type: "idle" };
          return;
        }
        O(d.scale > 1), d.gesture = { type: "idle" };
      } else if (k.touches.length === 1 && B.type === "pinch") {
        const N = k.touches[0];
        d.scale > 1 && N ? d.gesture = {
          type: "pan",
          startX: N.clientX,
          startY: N.clientY,
          startTx: d.tx,
          startTy: d.ty
        } : d.gesture = { type: "idle" };
      }
    }, ae = (k) => {
      Date.now() - d.lastTouchEndAt < Kn || (d.scale > 1 ? T() : (F(k.clientX, k.clientY, o, !0), O(!0)));
    }, he = (k) => {
      Y(k.clientX, k.clientY), !(d.scale <= 1) && F(k.clientX, k.clientY, d.scale, !1);
    }, _e = (k) => {
      z(), Y(k.clientX, k.clientY), y(!0);
    }, X = () => {
      y(!1), c && T();
    };
    return r.addEventListener("touchstart", V, {
      passive: !1
    }), r.addEventListener("touchmove", C, { passive: !1 }), r.addEventListener("touchend", D, { passive: !1 }), r.addEventListener("touchcancel", D, { passive: !1 }), r.addEventListener("click", ae), r.addEventListener("mousemove", he), r.addEventListener("mouseenter", _e), r.addEventListener("mouseleave", X), window.addEventListener("resize", z), window.addEventListener("scroll", z, {
      passive: !0,
      capture: !0
    }), () => {
      r.removeEventListener("touchstart", V), r.removeEventListener("touchmove", C), r.removeEventListener("touchend", D), r.removeEventListener("touchcancel", D), r.removeEventListener("click", ae), r.removeEventListener("mousemove", he), r.removeEventListener("mouseenter", _e), r.removeEventListener("mouseleave", X), window.removeEventListener("resize", z), window.removeEventListener("scroll", z, { capture: !0 });
    };
  }, [a, r, o, c, T]);
  const x = G.useCallback(
    (d) => {
      a && l(d);
    },
    [a]
  ), A = G.useCallback((d) => {
    u.current = d, d && (d.style.transformOrigin = "0 0", d.style.willChange = "transform", d.style.transform = "translate(0px, 0px) scale(1)");
  }, []), E = G.useCallback((d) => {
    h.current = d;
  }, []);
  return {
    containerRef: x,
    contentRef: A,
    cursorRef: E,
    containerProps: a ? {
      style: {
        touchAction: g ? "none" : "pan-y",
        cursor: i && b ? "none" : void 0
      }
    } : {},
    isZoomed: g,
    hasBeenZoomed: _,
    isHovering: b,
    reset: T
  };
}
const Pt = ({
  cursorRef: a,
  Cursor: o,
  isZoomed: n,
  isHovering: s
}) => /* @__PURE__ */ e(
  "div",
  {
    ref: a,
    "aria-hidden": "true",
    className: "absolute left-0 top-0 pointer-events-none will-change-transform",
    children: /* @__PURE__ */ e(o, { isZoomed: n, isHovering: s })
  }
), Le = t.object({
  template: t.literal("keen"),
  variants: t.custom().optional(),
  indicator: t.literal("number").or(t.literal("dots")).optional(),
  navigation: t.object({
    enabled: t.object({
      mobile: t.boolean().optional().default(!1),
      tablet: t.boolean().optional().default(!1),
      desktop: t.boolean().optional().default(!1)
    }),
    prevIcon: t.custom().optional(),
    nextIcon: t.custom().optional()
  }).optional(),
  slidesPerView: t.object({
    mobile: t.number().optional(),
    tablet: t.number().optional(),
    desktop: t.number().optional()
  }).optional(),
  gap: t.object({
    mobile: t.number().optional(),
    tablet: t.number().optional(),
    desktop: t.number().optional()
  }).optional(),
  children: t.custom().optional(),
  buttonInSlider: t.object({
    enabled: t.boolean().optional(),
    onClick: t.custom().optional(),
    label: t.string().optional()
  }).optional(),
  blueprint: t.custom().optional(),
  videoSettings: ja.optional(),
  customComponent: t.custom().optional(),
  zoom: t.boolean().optional(),
  zoomCursor: t.custom().optional()
}), Hn = P(
  "ImageGalleryAsKeen",
  S(
    Le,
    ({
      variants: a,
      indicator: o,
      navigation: n,
      slidesPerView: s,
      gap: i,
      children: c,
      buttonInSlider: r,
      videoSettings: l,
      customComponent: u,
      zoom: h,
      zoomCursor: g,
      ...v
    }) => {
      var F, Y, V;
      const {
        content: { media: _ }
      } = W(), b = (v.blueprint ?? ta).styles(a), [y, f] = G.useState(0);
      function L(C) {
        return (D) => {
          function ae() {
            D.slides.forEach((X) => {
              X.classList.remove("active");
            });
          }
          function he(X) {
            D.slides[X].classList.add("active");
          }
          function _e() {
            D.slides.forEach((X, k) => {
              X.addEventListener("click", () => {
                C.current && C.current.moveToIdx(k);
              });
            });
          }
          D.on("created", () => {
            C.current && (he(D.track.details.rel), _e(), C.current.on("animationStarted", (X) => {
              ae();
              const k = X.animator.targetIdx || 0;
              he(X.track.absToRel(k)), D.moveToIdx(Math.min(D.track.details.maxIdx, k));
            }));
          });
        };
      }
      const T = et(_, {
        key: ot,
        value: [!1, void 0]
      }), A = (T == null ? void 0 : T.length) === 1, E = G.useMemo(
        () => T.map((C) => C.src).join(","),
        [T]
      ), [H, d] = Ze({
        selector: ".keen-slider__slide",
        mode: "snap",
        loop: !A,
        breakpoints: {
          "(min-width: 0px)": {
            slides: {
              perView: A ? 1 : (s == null ? void 0 : s.mobile) ?? 1,
              spacing: (i == null ? void 0 : i.mobile) ?? 12
            }
          },
          "(min-width: 640px)": {
            slides: {
              perView: A ? 1 : (s == null ? void 0 : s.tablet) ?? 1,
              spacing: (i == null ? void 0 : i.tablet) ?? 24
            }
          },
          "(min-width: 1024px)": {
            slides: {
              perView: A ? 1 : (s == null ? void 0 : s.desktop) ?? 1,
              spacing: (i == null ? void 0 : i.desktop) ?? 20
            }
          }
        },
        slideChanged(C) {
          f(C.track.details.rel);
        }
      });
      G.useEffect(() => {
        f(0);
      }, [E]);
      const [z] = Ze(
        {
          initial: 0,
          slides: {
            perView: "auto",
            spacing: 4
          }
        },
        [L(d)]
      ), R = Oa({
        mobile: (F = n == null ? void 0 : n.enabled) == null ? void 0 : F.mobile,
        tablet: (Y = n == null ? void 0 : n.enabled) == null ? void 0 : Y.tablet,
        desktop: (V = n == null ? void 0 : n.enabled) == null ? void 0 : V.desktop
      }), O = G.useCallback(
        (C) => {
          const D = d.current;
          D && (C === "next" ? D.next() : D.prev());
        },
        []
      );
      return /* @__PURE__ */ p(
        "div",
        {
          className: b.base,
          "data-button-in-slider": (r == null ? void 0 : r.enabled) ?? !1,
          children: [
            /* @__PURE__ */ e(gt, { className: b.bundleSavingsBadge }),
            /* @__PURE__ */ p(
              "div",
              {
                ref: H,
                className: `keen-slider ${b.galleryWrapper}`,
                children: [
                  c,
                  T.map((C, D) => C ? /* @__PURE__ */ e(
                    Vn,
                    {
                      media: C,
                      position: D,
                      index: D,
                      slots: b,
                      currentSlide: y,
                      videoSettings: l,
                      zoom: h,
                      zoomCursor: g,
                      onSwipeAtEdge: O
                    },
                    `${C.src}-${D}`
                  ) : null),
                  u && u,
                  (r == null ? void 0 : r.enabled) && (r == null ? void 0 : r.onClick) && (r == null ? void 0 : r.label) && /* @__PURE__ */ e(
                    "button",
                    {
                      className: b.linkButton,
                      onClick: r.onClick,
                      children: r.label
                    }
                  ),
                  o === "number" && /* @__PURE__ */ p("span", { className: b.numberIndicator, children: [
                    "[ ",
                    y + 1,
                    " / ",
                    T.length,
                    " ]"
                  ] }),
                  o === "dots" && /* @__PURE__ */ e("span", { className: b.dotsIndicatorWrapper, children: T.map((C, D) => /* @__PURE__ */ e(
                    "button",
                    {
                      "data-is-active": y === D ? "true" : "false",
                      onClick: () => {
                        var ae;
                        return (ae = d.current) == null ? void 0 : ae.moveToIdx(D);
                      },
                      className: b.dotsIndicator
                    },
                    D
                  )) }),
                  !A && (n == null ? void 0 : n.prevIcon) && (n == null ? void 0 : n.nextIcon) && /* @__PURE__ */ p("div", { className: b.arrowsWrapper, ...R, children: [
                    /* @__PURE__ */ e(
                      "button",
                      {
                        className: b.leftArrow,
                        onClick: () => {
                          var C;
                          return (C = d.current) == null ? void 0 : C.prev();
                        },
                        children: n == null ? void 0 : n.prevIcon
                      }
                    ),
                    /* @__PURE__ */ e(
                      "button",
                      {
                        className: b.rightArrow,
                        onClick: () => {
                          var C;
                          return (C = d.current) == null ? void 0 : C.next();
                        },
                        children: n == null ? void 0 : n.nextIcon
                      }
                    )
                  ] })
                ]
              },
              E
            ),
            T.length > 1 && /* @__PURE__ */ e(
              "div",
              {
                ref: z,
                className: `keen-slider thumbnail ${b.thumbnailWrapper}`,
                children: T.map((C, D) => /* @__PURE__ */ e(
                  "div",
                  {
                    "data-is-active": y === D ? "true" : "false",
                    className: `keen-slider__slide relative ${b.thumbnail}`,
                    children: C.type === "image" && /* @__PURE__ */ e(
                      te,
                      {
                        image: { src: C.src, alt: (C == null ? void 0 : C.alt) ?? "dada" },
                        className: "w-full h-full"
                      }
                    )
                  },
                  `${C.src}-${D}`
                ))
              }
            )
          ]
        }
      );
    }
  )
), Vn = ({
  currentSlide: a,
  position: o,
  index: n,
  media: s,
  slots: i,
  videoSettings: c,
  zoom: r,
  zoomCursor: l,
  onSwipeAtEdge: u
}) => {
  const h = a !== n, g = Oe(s), v = s.type === "image" && g("model_is_wearing", t.string()), _ = s.type === "image" && g($e, t.boolean()), w = !!r && s.type === "image", {
    containerRef: b,
    contentRef: y,
    cursorRef: f,
    containerProps: L,
    isZoomed: T,
    hasBeenZoomed: x,
    isHovering: A,
    reset: E
  } = yt({
    enabled: w,
    onSwipeAtEdge: u,
    hideCursor: !!l
  });
  if (G.useEffect(() => {
    a !== n && T && E();
  }, [a, n, T, E]), !s)
    return null;
  const H = s.type === "image" && /* @__PURE__ */ e(
    te,
    {
      image: { src: s.src, alt: s.alt },
      className: i.image,
      fetchpriority: o < 2 ? "high" : "auto",
      loading: o < 2 ? "eager" : "lazy",
      displaySize: x ? vt : { mobile: "50vw", tablet: "80vw", desktop: "40vw" }
    }
  );
  return /* @__PURE__ */ p(
    "div",
    {
      ref: b,
      ...L,
      "data-is-active": a === n ? "true" : "false",
      className: `keen-slider__slide ${i.imageWrapper} relative`,
      children: [
        s.type !== "image" ? /* @__PURE__ */ e(nt, { src: s.src, loop: !0, autoPlay: !0, ...c }) : w ? /* @__PURE__ */ e("div", { ref: y, className: "w-full h-full", children: H }) : H,
        w && l && /* @__PURE__ */ e(
          Pt,
          {
            cursorRef: f,
            Cursor: l,
            isZoomed: T,
            isHovering: A
          }
        ),
        v && /* @__PURE__ */ e("div", { className: i.modelIsWearing, children: v.value }),
        _ && /* @__PURE__ */ e(ft, { media: s, className: i.shopTheLook }),
        h && /* @__PURE__ */ e("div", { className: i.peekingImage })
      ]
    },
    n
  );
}, St = t.object({
  template: t.literal("grid"),
  variants: t.custom().optional(),
  imageSettings: at.optional(),
  CustomComponent: t.custom().optional(),
  zoom: t.boolean().optional(),
  zoomCursor: t.custom().optional()
}), Un = P(
  "ImageGalleryAsGrid",
  S(
    St,
    ({ variants: a, imageSettings: o, CustomComponent: n, zoom: s, zoomCursor: i }) => {
      const {
        content: { media: c }
      } = W(), r = aa.styles(a), l = et(c, {
        key: ot,
        value: [!1, void 0]
      });
      return /* @__PURE__ */ p("div", { className: r.base, children: [
        /* @__PURE__ */ e(gt, { className: r.bundleSavingsBadge }),
        l.map(
          (u, h) => u && /* @__PURE__ */ e(
            $n,
            {
              media: u,
              CustomComponent: n,
              position: h,
              slots: r,
              imageSettings: o,
              amountOfImages: l.length,
              zoom: s,
              zoomCursor: i
            },
            h
          )
        )
      ] });
    }
  )
), $n = ({
  media: a,
  slots: o,
  position: n,
  amountOfImages: s,
  imageSettings: i,
  CustomComponent: c,
  zoom: r,
  zoomCursor: l
}) => {
  const u = Oe(a), h = a.type === "image" && u("model_is_wearing", t.string()), g = a.type === "image" && u($e, t.boolean()), v = n === s - 1, _ = s % 2 !== 0, w = !!r && a.type === "image", {
    containerRef: b,
    contentRef: y,
    cursorRef: f,
    containerProps: L,
    isZoomed: T,
    hasBeenZoomed: x,
    isHovering: A
  } = yt({
    enabled: w,
    hideCursor: !!l,
    resetOnMouseLeave: !0
  }), E = a.type === "image" && /* @__PURE__ */ e(
    te,
    {
      image: { src: a.src, alt: a.alt },
      className: o.image,
      fetchpriority: n < 5 ? "high" : "auto",
      loading: n < 5 ? "eager" : "lazy",
      ...i,
      displaySize: x ? vt : (i == null ? void 0 : i.displaySize) ?? {
        mobile: "90vw",
        tablet: "90vw",
        desktop: _ && v ? "60vw" : "25vw"
      }
    }
  );
  return /* @__PURE__ */ p(
    "div",
    {
      className: o.imageWrapper,
      "data-has-shop-the-look": g ? "true" : "false",
      "data-has-model-is-wearing": h ? "true" : "false",
      "data-position": n,
      children: [
        w ? /* @__PURE__ */ p(
          "div",
          {
            ref: b,
            ...L,
            className: "absolute inset-0 overflow-hidden",
            children: [
              /* @__PURE__ */ e("div", { ref: y, className: "w-full h-full", children: E }),
              l && /* @__PURE__ */ e(
                Pt,
                {
                  cursorRef: f,
                  Cursor: l,
                  isZoomed: T,
                  isHovering: A
                }
              )
            ]
          }
        ) : a.type === "image" ? E : /* @__PURE__ */ e(nt, { src: a.src, loop: !0, autoPlay: !0 }),
        h && /* @__PURE__ */ e("div", { className: o.modelIsWearing, children: h.value }),
        g && /* @__PURE__ */ e(ft, { media: a, className: o.shopTheLook }),
        c && /* @__PURE__ */ e(c, { position: n, amountOfImages: s })
      ]
    }
  );
}, wt = t.discriminatedUnion("template", [
  Le,
  St
]), Fn = P(
  "ImageGallery",
  S(wt, (a) => a.template === "keen" ? /* @__PURE__ */ e(Hn, { ...a }) : a.template === "grid" ? /* @__PURE__ */ e(Un, { ...a }) : null)
), _t = t.object({
  template: t.literal("table"),
  variants: t.custom().optional(),
  groupId: t.string().optional(),
  content: t.object({
    heading: t.string().optional(),
    headingTag: t.union([
      t.literal("h1"),
      t.literal("h2"),
      t.literal("h3"),
      t.literal("h4"),
      t.literal("h5"),
      t.literal("h6")
    ]).optional()
  }).optional()
}), Yn = P(
  "ProductSpecificationsAsTable",
  S(
    {
      schema: _t,
      defaultProps: {
        template: "table",
        groupId: "pdp_specifications"
      }
    },
    ({ variants: a, content: o, groupId: n }) => {
      const s = na.styles(a), i = (o == null ? void 0 : o.headingTag) || "h3", c = Ia(
        n ?? "pdp_specifications"
      );
      return !c || !c.length ? null : /* @__PURE__ */ p("div", { className: s.base, children: [
        (o == null ? void 0 : o.heading) && /* @__PURE__ */ e(i, { className: s.heading, children: o.heading }),
        /* @__PURE__ */ e("ol", { className: s.tableWrapper, children: c.map((r, l) => /* @__PURE__ */ p("li", { className: s.row, children: [
          /* @__PURE__ */ p("span", { className: s.label, children: [
            (r == null ? void 0 : r.icon) && /* @__PURE__ */ e("span", { className: s.icon, children: r.icon }),
            r.label
          ] }),
          /* @__PURE__ */ e("span", { className: s.value, children: r.value })
        ] }, l)) })
      ] });
    }
  )
), kt = t.discriminatedUnion("template", [
  _t
]), Xn = P(
  "ProductSpecifications",
  S(kt, (a) => a.template === "table" ? /* @__PURE__ */ e(Yn, { ...a }) : null)
), Qn = t.object({
  label: t.string(),
  barColor: t.string().optional(),
  /**
   * The key for the attribute.
   * @type {string}
   */
  attributeKey: t.string()
}), Fe = t.object({
  template: t.literal("progress-bar"),
  variants: t.custom().optional(),
  features: t.object({
    /** On a scale of. @default 10 */
    onAScaleOf: t.number()
  }).optional(),
  items: Qn.array().optional()
}), Zn = P(
  "AttributesAsProgressBar",
  S(
    Fe,
    ({
      variants: a,
      features: o = {
        onAScaleOf: 10
      },
      items: n
    }) => {
      const s = oa.styles(a), i = W(), c = ee(i);
      if (!n)
        return null;
      const r = n.map((l) => {
        var h;
        const u = (h = c(l.attributeKey, t.string())) == null ? void 0 : h.value;
        if (u)
          return {
            label: l.label,
            score: parseInt(u),
            barColor: l.barColor
          };
      }).filter(Ua);
      return r.length === 0 ? null : /* @__PURE__ */ e("div", { className: s.base, children: r.map((l, u) => /* @__PURE__ */ p("div", { className: s.item, children: [
        /* @__PURE__ */ e("div", { className: s.label, children: l.label }),
        /* @__PURE__ */ e("div", { className: s.bar, children: /* @__PURE__ */ e(
          J.div,
          {
            className: s.barFill,
            initial: { width: 0 },
            whileInView: {
              width: `${l.score / o.onAScaleOf * 100}%`
            },
            exit: { width: 0 },
            transition: { delay: u * 0.16 },
            style: {
              backgroundColor: l.barColor
            }
          }
        ) }),
        /* @__PURE__ */ p("div", { className: s.scoreLabel, children: [
          l.score,
          "/",
          o.onAScaleOf
        ] })
      ] }, u)) });
    }
  )
), Qs = t.string(), Ye = t.object({
  template: t.literal("tags"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string(),
  label: t.string().optional(),
  features: t.object({}).optional()
}), qn = P(
  "AttributesAsTags",
  S(Ye, ({ variants: a, attributeKey: o, label: n }) => {
    const s = sa.styles(a), i = K(
      o,
      t.union([
        t.string(),
        t.array(t.string()),
        t.array(t.object({ description: t.string() }))
      ])
    );
    if (!i)
      return null;
    const c = Array.isArray(i.value) ? i.value : [i.value];
    return c.length ? /* @__PURE__ */ p("div", { className: s.base, children: [
      n && /* @__PURE__ */ e("span", { className: s.label, children: n }),
      /* @__PURE__ */ e("div", { className: s.tags, children: c.map((r, l) => /* @__PURE__ */ e("div", { className: s.tag, children: typeof r == "object" ? r.description : r }, `${r}-${l}`)) })
    ] }) : null;
  })
), Nt = t.object({
  template: t.literal("icon-blocks"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string(),
  label: t.string().optional(),
  features: t.object({}).optional(),
  link: $a.optional()
}), Jn = P(
  "AttributesAsIconBlocks",
  S(
    Nt,
    ({ variants: a, attributeKey: o, label: n, link: s }) => {
      var r, l;
      const i = ia.styles(a), c = (r = K(
        o,
        t.array(
          t.object({
            description: t.string().optional(),
            image: t.object({
              url: t.string()
            }).optional()
          })
        )
      )) == null ? void 0 : r.value;
      if (c)
        return /* @__PURE__ */ p("div", { className: i.base, children: [
          /* @__PURE__ */ p("div", { className: i.header, children: [
            n && /* @__PURE__ */ e("span", { className: i.label, children: n }),
            ((l = s == null ? void 0 : s.link) == null ? void 0 : l.href) && /* @__PURE__ */ e(Fa, { as: "a", className: i.link, ...s })
          ] }),
          /* @__PURE__ */ e("div", { className: i.blocks, children: c.map(
            (u, h) => {
              var g;
              return (g = u.image) != null && g.url ? /* @__PURE__ */ p(
                "div",
                {
                  className: i.block,
                  children: [
                    /* @__PURE__ */ e(
                      te,
                      {
                        className: i.icon,
                        image: {
                          src: u.image.url,
                          alt: u.description
                        }
                      }
                    ),
                    /* @__PURE__ */ e("span", { className: i.description, children: u.description })
                  ]
                },
                `${u.description}-${h}`
              ) : null;
            }
          ) })
        ] });
    }
  )
), Tt = t.object({
  template: t.literal("row"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string().optional(),
  data: t.object({
    attributeLabel: t.string().optional(),
    value: t.string().optional().or(t.custom().optional())
  }).optional()
}), eo = P(
  "AttributesAsRow",
  S(Tt, ({ variants: a, attributeKey: o, data: n }) => {
    const s = ra.styles(a), i = I(), c = K(o || "", t.string()), { attributeLabel: r, value: l } = c || n || {};
    return !c && !n ? null : /* @__PURE__ */ p("div", { className: s.base, children: [
      r && /* @__PURE__ */ e("label", { className: s.label, children: i(r) }),
      /* @__PURE__ */ e("h4", { className: s.value, children: l })
    ] });
  })
), to = t.discriminatedUnion("template", [
  Fe,
  Ye,
  Nt,
  Tt
]), ao = P(
  "ProductAttributes",
  S(to, (a) => a.template === "progress-bar" ? /* @__PURE__ */ e(Zn, { ...a }) : a.template === "tags" ? /* @__PURE__ */ e(qn, { ...a }) : a.template === "icon-blocks" ? /* @__PURE__ */ e(Jn, { ...a }) : a.template === "row" ? /* @__PURE__ */ e(eo, { ...a }) : null)
), no = ({ className: a }) => /* @__PURE__ */ p(
  "svg",
  {
    className: a,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ e("defs", {}),
      /* @__PURE__ */ e("path", { d: "M0,5h12v2H0v-2Z" })
    ]
  }
), oo = ({ className: a }) => /* @__PURE__ */ p(
  "svg",
  {
    className: a,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ e("defs", {}),
      /* @__PURE__ */ e("polygon", { points: "12 5 7 5 7 0 5 0 5 5 0 5 0 7 5 7 5 12 7 12 7 7 12 7 12 5" })
    ]
  }
), so = t.object({
  setDisplayGoToCheckoutButton: t.custom(),
  amount: t.number(),
  slots: t.custom(),
  increaseButtonSettings: ue.optional(),
  decreaseButtonSettings: ue.optional()
}), io = P(
  "AddToCartQuanityPickerRow",
  S(
    so,
    ({
      setDisplayGoToCheckoutButton: a,
      slots: o,
      amount: n,
      decreaseButtonSettings: s,
      increaseButtonSettings: i
    }) => {
      const {
        addToCartMethod: c,
        removeFromCartMethod: r,
        quantityInCart: l,
        isAvailable: u
      } = Ie(), h = I();
      function g(v) {
        c.execute(v), a(!0);
      }
      return /* @__PURE__ */ p("div", { className: o.quantityPickerWrapper, children: [
        /* @__PURE__ */ e(
          fe,
          {
            ...s,
            disabled: l < n,
            progress: r.loadingState,
            onClick: () => r.execute(n)
          }
        ),
        /* @__PURE__ */ p("div", { className: o.quantityDisplay, children: [
          /* @__PURE__ */ e("span", { className: o.quantityText, children: n }),
          /* @__PURE__ */ e("span", { className: o.quantityUnit, children: h("PDP_Quantity_Picker_Suffix") })
        ] }),
        /* @__PURE__ */ e(
          fe,
          {
            ...i,
            progress: c.loadingState,
            disabled: !u,
            onClick: () => g(n)
          }
        )
      ] });
    }
  )
), Ct = t.object({
  template: t.literal("quantity-picker"),
  variants: t.custom().optional(),
  features: t.object({
    increaseButtonSettings: ue.optional(),
    decreaseButtonSettings: ue.optional(),
    itemSuffix: t.string().optional(),
    /** An optional boolean that determines whether the price should be displayed. @default true */
    showPrice: t.boolean().optional(),
    /** An optional array of numbers that defines the quantity options for adding items to the cart @default [1, 10] */
    addQuantityOptions: t.array(t.number()).optional(),
    postAddAction: t.union([t.literal("goToCheckoutButton"), t.literal("none")]).optional()
  }).optional()
}), ro = P(
  "AddToCartQuantityPicker",
  S(
    {
      schema: Ct,
      defaultProps: {
        template: "quantity-picker",
        features: {
          showPrice: !0,
          addQuantityOptions: [1, 10],
          postAddAction: "goToCheckoutButton",
          increaseButtonSettings: {
            variants: {
              width: "auto",
              size: "md",
              color: "primary"
            },
            iconRight: /* @__PURE__ */ e(oo, { className: "w-3 h-3" }),
            label: "Add"
          },
          decreaseButtonSettings: {
            variants: {
              width: "same-as-height",
              size: "md",
              color: "white"
            },
            iconLeft: /* @__PURE__ */ e(no, { className: "w-3 h-3" })
          }
        }
      }
    },
    ({ variants: a, features: o }) => {
      var b;
      const n = Pe(), s = la.styles(a), [i, c] = $(!1), r = I(), [l, u] = $(0);
      Ee(null);
      const {
        addToCartMethod: h,
        removeFromCartMethod: g,
        quantityInCart: v,
        isAvailable: _
      } = Ie(), w = () => {
        l && (l > v ? (h.execute(l - v), c(!0)) : l < v && g.execute(v - l));
      };
      return U(() => {
        u(0);
      }, [v]), /* @__PURE__ */ p("div", { className: s.base, children: [
        /* @__PURE__ */ p("div", { className: s.innerWrapper, children: [
          (o == null ? void 0 : o.showPrice) && /* @__PURE__ */ p(Q, { children: [
            /* @__PURE__ */ e(
              "span",
              {
                className: s.priceTag,
                "data-is-discounted": n.discountInfo ? "true" : "false",
                children: n.price.formatted
              }
            ),
            n.discountInfo && /* @__PURE__ */ e("span", { className: s.oldPriceTag, children: n.priceWithoutDiscount.formatted })
          ] }),
          /* @__PURE__ */ e("div", { className: s.currentQuantityWrapper, children: /* @__PURE__ */ p("div", { className: s.currentQuantityInputWrapper, children: [
            /* @__PURE__ */ e(
              "form",
              {
                onSubmit: (y) => {
                  y.preventDefault(), w();
                },
                children: /* @__PURE__ */ e(
                  "input",
                  {
                    onChange: (y) => {
                      y.preventDefault(), u(parseInt(y.target.value));
                    },
                    value: l > 0 ? l : "",
                    className: s.currentQuantityInput,
                    placeholder: v.toString(),
                    min: "0",
                    type: "number",
                    enterKeyHint: "done",
                    autoComplete: "off",
                    autoCorrect: "off",
                    spellCheck: "false"
                  }
                )
              }
            ),
            l > 0 ? /* @__PURE__ */ e(
              fe,
              {
                disabled: !_,
                onClick: w,
                className: s.updateButton,
                progress: l > v ? h.loadingState : g.loadingState,
                variants: {
                  size: "md",
                  width: "same-as-height"
                },
                label: r("PDP_Quantity_Picker_Update")
              }
            ) : /* @__PURE__ */ e("span", { className: s.currentQuantityUnit, children: r("PDP_Quantity_Picker_Suffix") })
          ] }) }),
          /* @__PURE__ */ e("div", { className: s.quantityPickersWrapper, children: (b = o == null ? void 0 : o.addQuantityOptions) == null ? void 0 : b.map((y, f) => /* @__PURE__ */ e(
            io,
            {
              increaseButtonSettings: o.increaseButtonSettings,
              decreaseButtonSettings: o.decreaseButtonSettings,
              amount: y,
              slots: s,
              setDisplayGoToCheckoutButton: c
            },
            f
          )) })
        ] }),
        /* @__PURE__ */ e(de, { children: i && /* @__PURE__ */ e(
          J.div,
          {
            initial: { marginTop: -50 },
            animate: { marginTop: 0 },
            transition: {
              type: "spring",
              stiffness: 300,
              damping: 15,
              mass: 0.5
            },
            children: /* @__PURE__ */ e(
              oe,
              {
                as: "a",
                variants: {
                  width: "full",
                  style: "solid",
                  color: "black"
                },
                label: r("PDP_Go_To_Checkout"),
                link: { href: "checkout" }
              }
            )
          }
        ) })
      ] });
    }
  )
), At = {
  available: "PDP_Add_To_Cart",
  "out-of-stock": "PDP_Out_Of_Stock",
  discontinued: "PDP_Discontinued",
  "not-determined": "PDP_Select_Size"
}, lo = (a) => {
  const o = De(), n = I(), s = o.status === "out-of-stock" && a ? n("Notify_Me_Submit_Label") : n(At[o.status]) ?? "PDP_Select_Size";
  return n(s);
}, Bt = t.object({
  template: t.literal("button"),
  variants: t.custom().optional(),
  buttonSettings: ue.optional(),
  animateAddToCartLabel: t.boolean().optional(),
  postAddAction: t.union([
    t.literal("goToCheckoutButton"),
    t.literal("showMinicart"),
    t.literal("none")
  ]).optional(),
  isNotifyMeEnabled: t.boolean().optional()
}), co = P(
  "AddToCartButton",
  S(
    {
      schema: Bt,
      defaultProps: {
        template: "button",
        animateAddToCartLabel: !0,
        postAddAction: "showMinicart",
        isNotifyMeEnabled: !1
      }
    },
    ({
      variants: a,
      buttonSettings: o,
      animateAddToCartLabel: n,
      postAddAction: s,
      isNotifyMeEnabled: i
    }) => {
      const c = ca.styles(a), { addToCartMethod: r, isAvailable: l, isOutOfStock: u, isDiscontinued: h } = Ie(), g = u && i, v = lo(g), _ = I(), w = typeof window < "u" && window.location.pathname.includes("/checkout"), [b, y] = $(!1), f = Ge(async () => {
        if (!h) {
          if (u && i) {
            ce.emit("open", { overlayId: "notify-me" });
            return;
          } else if (!l) {
            qa.error(_("Add_To_Cart_Error_Not_Available_Toast"));
            return;
          }
          await r.execute(), s === "goToCheckoutButton" && y(!0), s === "showMinicart" && !w && ce.emit("open", { overlayId: "mini-cart" });
        }
      }, [
        u,
        i,
        r,
        s,
        _,
        w
      ]), L = Xt(
        () => n ? /* @__PURE__ */ e(de, { mode: "wait", initial: !1, children: /* @__PURE__ */ e(
          J.span,
          {
            exit: {
              y: "-190%",
              opacity: 0.7,
              transition: {
                duration: 0.15
              }
            },
            initial: {
              y: "150%",
              opacity: 0.7
            },
            animate: {
              y: 0,
              opacity: 1,
              transition: {
                duration: 0.15
              }
            },
            children: v
          },
          v
        ) }) : v,
        [n, v]
      );
      return /* @__PURE__ */ p("div", { className: c.base, id: "add-to-cart-component", children: [
        /* @__PURE__ */ e(
          oe,
          {
            as: "button",
            variants: {
              width: "full"
            },
            ...o,
            progress: r.loadingState,
            dataAttr: {
              "appear-disabled": (u || h) && !g
            },
            "aria-disabled": !l && !g ? "true" : "false",
            label: L,
            onClick: f
          }
        ),
        /* @__PURE__ */ e(de, { initial: !1, children: b && /* @__PURE__ */ e(
          J.div,
          {
            initial: { y: "-100%" },
            animate: { y: 0 },
            transition: {
              duration: 0.5,
              ease: it(0.32, 0.72, 0, 1)
            },
            children: /* @__PURE__ */ e(
              oe,
              {
                as: "a",
                variants: {
                  width: "full",
                  color: "black",
                  style: "outline"
                },
                label: _("PDP_Go_To_Checkout"),
                link: { href: "checkout" }
              }
            )
          }
        ) })
      ] });
    }
  )
), Dt = t.discriminatedUnion("template", [
  Ct,
  Bt
]), uo = P(
  "ProductAddToCart",
  S(Dt, (a) => Z() === "bundle" ? null : a.template === "button" ? /* @__PURE__ */ e(co, { ...a }) : a.template === "quantity-picker" ? /* @__PURE__ */ e(ro, { ...a }) : null)
), Se = t.object({
  template: t.literal("button-grid"),
  variants: t.custom().optional(),
  notifyMe: t.object({
    enabled: t.boolean().optional(),
    icon: t.custom().optional()
  }).optional(),
  lowStockIndicator: t.object({
    /**
     * Enables/disables the low stock indicator functionality
     * @default false
     */
    enabled: t.boolean().optional(),
    /**
     * Display a component to indicate low stock
     */
    headerContent: t.custom().optional(),
    /**
     * Threshold value below which stock is considered low
     * Triggers visual indicator when stock drops below this number
     * @default 5
     */
    lowStockLimit: t.number().optional()
  }).optional(),
  headerContent: t.custom().optional()
}), po = P(
  "SizePickerButtonGrid",
  S(
    Se,
    ({ variants: a, notifyMe: o, lowStockIndicator: n, headerContent: s }) => {
      var w;
      const i = da.styles(a), { optionGroups: c, selectOption: r, selectedOptions: l } = Me(), u = I(), h = c.length === 1 && ((w = c[0]) == null ? void 0 : w.options.length) === 1;
      if (h)
        return null;
      U(() => {
        var b;
        h && ((b = c[0]) != null && b.options[0]) && r(
          c[0].dimensionKey,
          c[0].options[0]
        );
      }, []);
      const g = (n == null ? void 0 : n.lowStockLimit) ?? 5, v = (b) => (n == null ? void 0 : n.enabled) === !0 && b.inventory.inStock && b.inventory.quantity < g, _ = c.some(
        (b) => b.options.some(v)
      );
      return /* @__PURE__ */ p("div", { className: i.base, children: [
        /* @__PURE__ */ p("div", { className: i.header, children: [
          /* @__PURE__ */ e("span", { children: u("PDP_Size_Picker_Select_Size") }),
          _ ? n == null ? void 0 : n.headerContent : s
        ] }),
        c.map((b) => /* @__PURE__ */ e("div", { className: i.wrapper, children: b.options.map((y) => {
          var A;
          const f = ((A = l[b.dimensionKey]) == null ? void 0 : A.dimensionValue) === y.dimensionValue, L = y.inventory.inStock, T = v(y), x = () => {
            r(b.dimensionKey, y);
          };
          return /* @__PURE__ */ p(
            "button",
            {
              type: "button",
              "data-is-selected": f ? "true" : "false",
              "data-is-out-of-stock": L ? "false" : "true",
              disabled: !L && !(o != null && o.enabled),
              className: i.size,
              "aria-label": y.label,
              onClick: x,
              children: [
                T && (n == null ? void 0 : n.enabled) && /* @__PURE__ */ e("span", { className: i.lowStockIndicator }),
                (o == null ? void 0 : o.enabled) && !L && o.icon,
                y.label
              ]
            },
            y.dimensionValue
          );
        }) }, b.dimensionKey))
      ] });
    }
  )
), mo = {
  direction: "right",
  variants: {
    rounded: "none"
  }
}, ho = {
  style: "outline",
  width: "full"
}, ve = t.object({
  template: t.literal("modal"),
  variants: t.custom().optional(),
  drawerSettings: t.custom().optional().describe("Settings for the drawer"),
  buttonVariants: t.custom().optional().describe("Variants for the button"),
  triggerLabel: t.string().optional(),
  sizeButtons: We.optional(),
  aboveButtonComponent: t.custom().optional(),
  belowButtonComponent: t.custom().optional(),
  customOverlayId: t.string().optional()
}), bo = () => {
  const [a, o] = $(
    typeof window < "u" ? window.innerWidth > 1024 : !1
  );
  return U(() => {
    const n = () => {
      o(window.innerWidth > 1024);
    };
    return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), a;
}, go = P(
  "SizePickerModal",
  S(
    {
      schema: ve,
      defaultProps: {
        template: "modal",
        drawerSettings: mo,
        buttonVariants: ho,
        sizeButtons: {
          variants: {
            rounded: "full",
            width: "same-as-height",
            size: "md",
            color: "black",
            style: "outline"
          }
        },
        customOverlayId: "size-picker-modal"
      }
    },
    ({
      variants: a,
      drawerSettings: o,
      buttonVariants: n,
      triggerLabel: s,
      sizeButtons: i,
      aboveButtonComponent: c,
      belowButtonComponent: r,
      customOverlayId: l
    }) => {
      const u = I(), h = bo(), g = ua.styles(a), { optionGroups: v, selectOption: _, selectedOptions: w } = Me();
      return /* @__PURE__ */ p(
        j,
        {
          hasOverlay: !0,
          ...o,
          variants: {
            direction: h ? "right" : "bottom",
            ...(o ?? {}).variants
          },
          customOverlayId: l ?? "size-picker-modal",
          direction: h ? "right" : "bottom",
          children: [
            /* @__PURE__ */ e(j.Trigger, { className: g.trigger, children: /* @__PURE__ */ e(
              rt,
              {
                label: s ?? u("Size_Picker_Select_Size"),
                variants: n
              }
            ) }),
            /* @__PURE__ */ p(j.Content, { children: [
              /* @__PURE__ */ e("div", { className: g.optionsWrapper, children: v.map((b) => /* @__PURE__ */ p(
                "div",
                {
                  className: g.wrapper,
                  "data-dimension-key": b.dimensionKey,
                  "data-dimension-label": b.dimensionLabel,
                  children: [
                    /* @__PURE__ */ e("div", { className: g.header, children: /* @__PURE__ */ e("h3", { className: g.heading, children: u(`Size_Picker_${b.dimensionLabel}`) }) }),
                    /* @__PURE__ */ e("div", { className: g.sizeWrapper, children: b.options.map((y, f) => {
                      var T;
                      const L = ((T = w[b.dimensionKey]) == null ? void 0 : T.dimensionValue) === y.dimensionValue;
                      return /* @__PURE__ */ e(
                        fe,
                        {
                          dataAttr: {
                            "is-selected": L,
                            "is-out-of-stock": !y.inventory.inStock
                          },
                          className: g.size,
                          onClick: () => _(b.dimensionKey, y),
                          label: y.label,
                          ...i
                        },
                        `${y.label}-${f}`
                      );
                    }) })
                  ]
                },
                b.dimensionKey
              )) }),
              c,
              /* @__PURE__ */ e(m.AddToCart, { template: "button" }),
              r
            ] })
          ]
        }
      );
    }
  )
), fo = t.discriminatedUnion("template", [
  Se,
  ve
]), vo = P(
  "ProductSizePicker",
  S(fo, (a) => Z() !== "with_variants" ? null : a.template === "button-grid" ? /* @__PURE__ */ e(po, { ...a }) : a.template === "modal" ? /* @__PURE__ */ e(go, { ...a }) : null)
), Xe = t.object({
  template: t.literal("image-card"),
  colorAttributeKey: t.string().optional(),
  variants: t.custom().optional(),
  headingTag: t.enum(["h1", "h2", "h3", "h4", "h5", "h6"]).optional(),
  hide: t.boolean().optional()
}), yo = P(
  "SiblingsImageCard",
  S(
    {
      schema: Xe,
      defaultProps: {
        template: "image-card",
        colorAttributeKey: "product_color",
        headingTag: "h2"
      }
    },
    ({ variants: a, colorAttributeKey: o, headingTag: n }) => {
      const s = I(), i = pa.styles(a), c = K(
        o ?? "",
        t.string()
      ), r = W(), l = tt(), u = n ?? "h2";
      return l.length ? /* @__PURE__ */ p("div", { className: i.base, children: [
        c && /* @__PURE__ */ e(u, { className: i.header, children: s("PDP_Siblings_Header_Title", {
          color: c.value,
          colorName: c.valueLabel
        }) }),
        /* @__PURE__ */ e("div", { className: i.siblingsWrapper, children: l.map((h, g) => {
          var v, _, w, b, y, f;
          return (w = (_ = (v = h.content) == null ? void 0 : v.media) == null ? void 0 : _[0]) != null && w.src ? /* @__PURE__ */ e(
            ye,
            {
              productBase: h,
              context: "product-sibling",
              className: i.sibling,
              "data-is-selected": h.productId === r.productId,
              children: /* @__PURE__ */ e(
                te,
                {
                  image: { src: (f = (y = (b = h.content) == null ? void 0 : b.media) == null ? void 0 : y[0]) == null ? void 0 : f.src },
                  displaySize: {
                    mobile: "80px",
                    tablet: "80px",
                    desktop: "80px"
                  },
                  className: i.siblingImage
                }
              )
            },
            g
          ) : null;
        }) })
      ] }) : null;
    }
  )
), Po = (a) => /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(a), So = (a) => /^[a-zA-Z]+$/.test(a) || /^[a-zA-Z]+\s[a-zA-Z]+$/.test(a), wo = (a) => /^rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)$/.test(a) || /^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*[\d.]+\s*\)$/.test(a), _o = (a) => a.startsWith("http") || a.startsWith("/") || /\.(png|jpe?g|gif|svg|webp)$/i.test(a), It = ({
  sibling: a,
  colorSwatchAttributeKey: o,
  className: n
}) => {
  const s = W(), i = ee(a);
  if (!o)
    return null;
  const c = i(
    o,
    t.string()
  );
  if (!(c != null && c.valueLabel))
    return null;
  const r = c.valueLabel, l = c.value, u = () => l ? _o(l) ? {
    backgroundImage: `url(${l})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  } : Po(l) || So(l) || wo(l) ? { backgroundColor: l } : { backgroundColor: "#cccccc" } : {}, h = `${r || ""} color option`;
  return /* @__PURE__ */ e(
    ye,
    {
      productBase: a,
      context: "product-sibling",
      className: n,
      style: u(),
      "data-is-selected": s.productId === a.productId,
      "data-is-white": l === "#ffffff" || (r == null ? void 0 : r.toLocaleLowerCase()) === "white" || (r == null ? void 0 : r.toLocaleLowerCase()) === "vit",
      "aria-label": h,
      title: r || "",
      role: "button",
      "data-testid": `color-swatch-${r == null ? void 0 : r.toLowerCase().replace(/\s+/g, "-")}`
    },
    a.productKey
  );
}, Lt = t.object({
  template: t.literal("color-swatch"),
  colorSwatchAttributeKey: t.string().optional(),
  variants: t.custom().optional(),
  hide: t.boolean().optional()
}), ko = P(
  "SiblingColorSwatchList",
  S(
    {
      schema: Lt,
      defaultProps: {
        template: "color-swatch",
        colorSwatchAttributeKey: "product_color"
      }
    },
    ({ variants: a, colorSwatchAttributeKey: o }) => {
      const n = ma.styles(a), s = W(), i = I(), c = tt(), r = ee(s);
      if (!o || !c.length)
        return null;
      const l = r(
        o,
        t.string()
      );
      return l ? /* @__PURE__ */ p("div", { className: n.base, children: [
        /* @__PURE__ */ e("div", { className: n.header, children: i("PDP_Product_ColorSwatch_Label", {
          color: l.valueLabel
        }) }),
        /* @__PURE__ */ e("div", { className: n.siblingsWrapper, children: c.map((u, h) => /* @__PURE__ */ e(
          It,
          {
            sibling: u,
            colorSwatchAttributeKey: o,
            className: n.sibling
          },
          `sibling.productKey-${h}`
        )) })
      ] }) : null;
    }
  )
), we = t.discriminatedUnion("template", [
  Xe,
  Lt
]), No = P(
  "ProductSiblings",
  S(we, (a) => a.hide === !0 ? null : a.template === "image-card" ? /* @__PURE__ */ e(yo, { ...a }) : a.template === "color-swatch" ? /* @__PURE__ */ e(ko, { ...a }) : null)
), zt = t.object({
  template: t.literal("image-cards"),
  swiperSettings: ct.optional(),
  relationType: t.string().optional(),
  productCardSettings: Ja.optional()
}), To = (a) => {
  const o = tn(), n = I();
  if (!o || o.length === 0)
    return null;
  const s = ha.styles();
  return /* @__PURE__ */ p("div", { className: s.base, children: [
    /* @__PURE__ */ e("h3", { className: s.heading, children: n("PDP_Related_Products_Image_Cards_Heading") }),
    /* @__PURE__ */ e("div", { className: s.wrapper, children: o.slice(0, 3).map((i, c) => i.type !== "product" ? null : /* @__PURE__ */ e(
      je,
      {
        product: i.product,
        context: {
          type: "plp",
          listId: "related-products",
          listName: "Related Products",
          position: c
        },
        children: /* @__PURE__ */ e(en, { templateProps: a.productCardSettings })
      },
      c
    )) })
  ] });
}, xt = P(
  "ProductRelatedProductsImageCards",
  S(zt, ({ relationType: a, ...o }) => {
    const n = Be(a);
    if (!xt.length)
      return null;
    const s = {
      items: n.map((i) => ({ type: "product", product: i.product })),
      meta: {
        currentPage: 1,
        totalPages: 5,
        itemsPerPage: 12,
        totalItems: n.length
      },
      facets: [],
      sort: []
    };
    return /* @__PURE__ */ e(lt, { result: s, children: /* @__PURE__ */ e(To, { ...o }) });
  })
), Rt = t.object({
  template: t.literal("swiper"),
  swiperSettings: ct.optional(),
  relationType: t.string().optional()
}), Co = P(
  "ProductRelatedProductsSwiper",
  S(Rt, ({ swiperSettings: a, relationType: o }) => {
    const n = Be(o);
    if (!n.length)
      return null;
    const s = {
      items: n.map((i) => ({ type: "product", product: i.product })),
      meta: {
        currentPage: 1,
        totalPages: 5,
        itemsPerPage: 12,
        totalItems: n.length
      },
      sort: [],
      facets: []
    };
    return /* @__PURE__ */ e(lt, { result: s, children: /* @__PURE__ */ e(an, { ...a }) });
  })
), ie = t.discriminatedUnion("template", [
  zt,
  Rt
]), Ao = P(
  "RelatedProducts",
  S(ie, (a) => a.template === "image-cards" ? /* @__PURE__ */ e(xt, { ...a }) : a.template === "swiper" ? /* @__PURE__ */ e(Co, { ...a }) : null)
), Bo = ({
  targetSelector: a,
  mode: o = "isNotVisible"
}) => {
  const [n, s] = $(!1), i = Ee(null), c = Ee(null);
  U(() => {
    if (o === "isAlwaysVisible") {
      s(!0);
      return;
    } else if (o === "isAlwaysHidden") {
      s(!1);
      return;
    }
  }, [o]);
  const r = Ge(() => {
    if (!i.current)
      return;
    const u = i.current.getBoundingClientRect();
    switch (o) {
      case "isScrolledPast":
        s(u.bottom <= 0);
        break;
      case "isBeforeView":
        s(u.top >= window.innerHeight);
        break;
    }
  }, [o]), l = Ge(() => {
    c.current && cancelAnimationFrame(c.current), c.current = requestAnimationFrame(() => {
      r(), c.current = null;
    });
  }, [r]);
  return U(() => {
    if (o === "isAlwaysVisible" || o === "isAlwaysHidden" || (i.current = document.querySelector(a), !i.current))
      return;
    let u = null;
    return o === "isVisible" || o === "isNotVisible" ? (u = new IntersectionObserver(
      ([h]) => {
        h && s(
          o === "isVisible" ? h.isIntersecting : !h.isIntersecting
        );
      },
      { threshold: 0.1 }
    ), u.observe(i.current)) : (r(), window.addEventListener("scroll", l, { passive: !0 }), window.addEventListener("resize", l, { passive: !0 })), () => {
      u ? u.disconnect() : (window.removeEventListener("scroll", l), window.removeEventListener("resize", l)), c.current && cancelAnimationFrame(c.current);
    };
  }, [a, o, r, l]), n;
}, Et = t.object({
  template: t.literal("button"),
  variants: t.custom().optional(),
  buttonSettings: ue.optional(),
  mode: t.custom().optional(),
  targetSelector: t.string().optional(),
  selectSizeAction: t.union([t.literal("open-size-picker"), t.literal("scroll-to-size-picker")]).optional(),
  withSizePicker: t.boolean().optional(),
  sizePickerOverlayId: t.string().optional(),
  showPrice: t.boolean().optional()
}), Do = P(
  "StickyAddToCartButton",
  S(
    {
      schema: Et,
      defaultProps: {
        template: "button",
        mode: "isScrolledPast",
        targetSelector: "#add-to-cart-component",
        selectSizeAction: "scroll-to-size-picker",
        withSizePicker: !1,
        sizePickerOverlayId: "size-picker-modal",
        showPrice: !0
      }
    },
    ({
      variants: a,
      buttonSettings: o,
      mode: n,
      targetSelector: s,
      selectSizeAction: i,
      withSizePicker: c,
      sizePickerOverlayId: r,
      showPrice: l
    }) => {
      const u = ba.styles(a), { addToCartMethod: h, isAvailable: g } = Ie(), v = De(), _ = I(), { selectedOptions: w } = Me(), b = Object.values(w).filter((A) => !!A).map((A) => A.label).join(" / "), y = Pe(), f = Bo({
        targetSelector: s ?? "#add-to-cart-component",
        mode: n
      }), L = typeof window < "u" && window.location.pathname.includes("/checkout"), T = () => {
        ce.emit("open", {
          overlayId: r ?? "size-picker-modal"
        });
      }, x = async () => {
        if (!g) {
          if (i === "open-size-picker") {
            T();
            return;
          }
          if (i === "scroll-to-size-picker") {
            const A = document.getElementById("add-to-cart-component");
            A == null || A.scrollIntoView({
              behavior: "smooth",
              block: "end"
            });
            return;
          }
        }
        await h.execute(), L || ce.emit("open", { overlayId: "mini-cart" });
      };
      return v.status === "out-of-stock" ? null : c ? /* @__PURE__ */ e(
        "div",
        {
          className: u.base,
          "data-is-visible": f ? "true" : "false",
          children: /* @__PURE__ */ p("div", { className: u.buttonsWrapper, children: [
            /* @__PURE__ */ e(
              oe,
              {
                as: "button",
                variants: {
                  width: "full",
                  style: "outline",
                  color: "black"
                },
                label: g ? b : _("PDP_Select_Size"),
                onClick: T
              }
            ),
            /* @__PURE__ */ e(
              oe,
              {
                as: "button",
                variants: {
                  width: "full"
                },
                ...o,
                progress: h.loadingState,
                label: /* @__PURE__ */ p(Q, { children: [
                  _("PDP_Add_To_Cart"),
                  l && /* @__PURE__ */ p(Q, { children: [
                    " ",
                    /* @__PURE__ */ e("span", { children: y.price.formatted })
                  ] })
                ] }),
                onClick: x
              }
            )
          ] })
        }
      ) : /* @__PURE__ */ e(
        "div",
        {
          className: u.base,
          "data-is-visible": f ? "true" : "false",
          children: /* @__PURE__ */ e(
            oe,
            {
              as: "button",
              variants: {
                width: "full",
                justifyContent: "between"
              },
              ...o,
              progress: h.loadingState,
              label: /* @__PURE__ */ p(Q, { children: [
                _(g ? "PDP_Add_To_Cart" : "PDP_Select_Size"),
                l && /* @__PURE__ */ p(Q, { children: [
                  " ",
                  /* @__PURE__ */ e("span", { children: y.price.formatted })
                ] })
              ] }),
              onClick: x
            }
          )
        }
      );
    }
  )
), Io = t.discriminatedUnion("template", [
  Et
]), Lo = P(
  "ProductStickyAddToCart",
  S(Io, (a) => Z() !== "with_variants" ? null : a.template === "button" ? /* @__PURE__ */ e(Do, { ...a }) : null)
), zo = () => Z() !== "bundle" ? null : /* @__PURE__ */ e(xo, {}), xo = () => {
  const { sections: a } = Ke(), o = Ce.styles();
  return /* @__PURE__ */ p("div", { className: o.base, children: [
    /* @__PURE__ */ e("div", { className: o.sectionsWrapper, children: Object.values(a).map((n, s) => /* @__PURE__ */ e(
      je,
      {
        product: n.activeProduct.product,
        context: {
          type: "plp",
          listId: "bundle-section",
          listName: "Bundle Section",
          position: s
        },
        children: /* @__PURE__ */ e(Ro, { section: n, index: s })
      },
      s
    )) }),
    /* @__PURE__ */ e(Wo, {}),
    /* @__PURE__ */ e(Oo, {})
  ] });
}, Ro = ({
  section: a,
  index: o
}) => {
  const n = W(), { selectSectionProduct: s } = Ke(), i = Ce.styles(), c = I(), r = (l) => {
    s(a.sectionId, l);
  };
  return /* @__PURE__ */ p("div", { className: i.section, children: [
    /* @__PURE__ */ e(de, { mode: "wait", initial: !1, children: /* @__PURE__ */ e("div", { className: i.productNameWrapper, children: /* @__PURE__ */ e(
      J.h3,
      {
        className: i.productName,
        exit: {
          y: "-100%"
        },
        initial: {
          y: "100%"
        },
        animate: {
          y: 0
        },
        transition: {
          duration: 0.35,
          ease: it(0.32, 0.72, 0, 1)
        },
        children: c("PDP_Bundle_Selection_Product", {
          index: o + 1,
          product: n.content.name
        })
      }
    ) }, n.content.name) }),
    /* @__PURE__ */ e("h3", { className: i.selectionHeading, children: c("PDP_Bundle_Selection_Heading") }),
    /* @__PURE__ */ e("div", { className: i.productSlider, children: a.products.map((l, u) => {
      const h = l.base.productId === a.activeProduct.product.base.productId;
      return /* @__PURE__ */ e(
        Eo,
        {
          product: l,
          isSelected: h,
          onClick: () => r(l)
        },
        u
      );
    }) }),
    /* @__PURE__ */ e(Go, { sectionId: a.sectionId }),
    /* @__PURE__ */ e(
      Ya,
      {
        link: { href: a.activeProduct.product.base.slug },
        label: c("PDP_Bundle_Selection_Link"),
        className: i.link
      }
    )
  ] });
}, Eo = ({
  product: a,
  isSelected: o,
  onClick: n
}) => {
  var l;
  const s = Ce.styles(), i = (l = a.base.content.media) == null ? void 0 : l[0], r = ee(a.base)("product_color", t.string());
  return /* @__PURE__ */ p(
    "button",
    {
      className: s.productWrapper,
      onClick: n,
      "data-is-selected": o ? "true" : "false",
      children: [
        i && /* @__PURE__ */ e(te, { className: s.productImage, image: i }),
        r && /* @__PURE__ */ p("div", { className: s.swatchWrapper, children: [
          /* @__PURE__ */ e(
            It,
            {
              sibling: a.base,
              colorSwatchAttributeKey: "colorSwatch",
              className: s.swatch
            }
          ),
          /* @__PURE__ */ e("span", { className: s.swatchLabel, children: r == null ? void 0 : r.valueLabel })
        ] })
      ]
    }
  );
}, Go = ({ sectionId: a }) => {
  const o = Z(), n = De(), { selectSectionSize: s } = Ke(), i = I(), c = n.status === "available" ? n.availableItemId : void 0;
  switch (U(() => {
    s(a, c);
  }, [c]), o) {
    case "with_variants":
      return /* @__PURE__ */ e(m.SizePicker, { template: "button-grid" });
    case "simple":
      return /* @__PURE__ */ e(
        "button",
        {
          "data-is-selected": n.status === "out-of-stock" ? "false" : "true",
          "data-is-out-of-stock": n.status === "out-of-stock" ? "true" : "false",
          className: "w-1/2 h-10 text-label-sm uppercase font-medium bg-transparent rounded-md border data-[is-out-of-stock=true]:text-less-emphasis-3 data-[is-selected=true]:text-white data-[is-selected=true]:bg-black relative data-[is-out-of-stock=true]:before:absolute data-[is-out-of-stock=true]:before:w-[1px] data-[is-out-of-stock=true]:before:h-[140%] data-[is-out-of-stock=true]:before:bg-less-emphasis-3 data-[is-out-of-stock=true]:before:top-[-20%] before:left-1/2 before:-translate-x-1/2 before:rotate-45 [&>svg]:w-5 [&>svg]:h-5",
          children: i("PDP_Size_Picker_One_Size")
        }
      );
    default:
      return null;
  }
}, Wo = () => {
  const a = Ae(), o = Ce.styles(), n = I();
  return /* @__PURE__ */ p("div", { className: o.totalsWrapper, children: [
    /* @__PURE__ */ p("div", { className: o.totalsRow, children: [
      /* @__PURE__ */ e("span", { className: o.totalsLabel, children: n("PDP_Bundle_Discount_Label") }),
      /* @__PURE__ */ p("span", { className: o.totalsValue, children: [
        "-",
        a.discountFromPriceOfItemsOutsideBundle.formatted
      ] })
    ] }),
    /* @__PURE__ */ p("div", { className: o.totalsRow, children: [
      /* @__PURE__ */ e("span", { className: o.totalsLabel, children: n("PDP_Bundle_Price_Label") }),
      /* @__PURE__ */ e("span", { className: o.totalsValue, children: a.priceInfo.price.formatted })
    ] })
  ] });
}, Oo = () => {
  const a = La(), o = za(), { execute: n } = Ka("addBundleToCart"), [s, i] = G.useState("default"), c = I(), r = async () => {
    if (o.status === "available")
      try {
        i("loading"), await n({
          itemId: a,
          sections: o.sections.map((u) => ({
            sectionId: u.sectionId,
            itemId: u.availableItemId
          }))
        }), await new Promise((u) => setTimeout(u, 1e3)), i("complete"), await new Promise((u) => setTimeout(u, 1e3));
      } catch {
        i("default"), await new Promise((h) => setTimeout(h, 1e3));
      } finally {
        i("default"), ce.emit("open", { overlayId: "mini-cart" });
      }
  }, l = o.status === "available";
  return /* @__PURE__ */ e(
    oe,
    {
      as: "button",
      variants: {
        width: "full"
      },
      progress: s,
      "aria-disabled": l ? "false" : "true",
      label: c(At[o.status]),
      onClick: r
    }
  );
}, me = t.object({
  items: t.array(
    t.object({
      label: t.string().optional(),
      icon: t.custom().optional()
    })
  ).optional(),
  attributeKey: t.string().optional(),
  variants: t.custom().optional()
}), jo = P(
  "ProductUspBlock",
  S(
    {
      schema: me,
      defaultProps: {
        attributeKey: "usps"
      }
    },
    ({ items: a, variants: o, attributeKey: n }) => {
      var c, r;
      const s = ga.styles(o), i = (c = K(
        n ?? "usps",
        t.array(
          t.object({
            label: t.string(),
            icon: t.string().optional()
          })
        )
      )) == null ? void 0 : c.value;
      return !a && !i ? null : /* @__PURE__ */ e("div", { className: s.base, children: (r = a ?? i) == null ? void 0 : r.map((l, u) => /* @__PURE__ */ p("div", { className: s.item, children: [
        l.icon,
        /* @__PURE__ */ e("span", { className: s.label, children: l.label })
      ] }, u)) });
    }
  )
), Gt = t.object({
  template: t.literal("scale"),
  variants: t.custom().optional(),
  /**
   * On a scale of. @default 10
   * @type {number}
   *  */
  onAScaleOf: t.number().optional()
}), Mo = P(
  "ProductSizeRecommendationScale",
  S(
    {
      schema: Gt,
      defaultProps: {
        template: "scale",
        onAScaleOf: 10
      }
    },
    ({ onAScaleOf: a }) => {
      W();
      const o = fa.styles(), n = I(), s = K(
        "sizeRecommendation",
        t.string()
      ), i = K(
        "sizeRecommendationScale",
        t.string()
      );
      if (!(!(i != null && i.value) || !(s != null && s.value)))
        return /* @__PURE__ */ p("div", { className: o.base, children: [
          (i == null ? void 0 : i.value) && i.value && /* @__PURE__ */ p(Q, { children: [
            /* @__PURE__ */ e("h3", { className: o.label, children: n("PDP_Size_Recommendation_Scale_Label") }),
            /* @__PURE__ */ e("div", { className: o.bar, children: /* @__PURE__ */ e(
              J.div,
              {
                className: o.dot,
                initial: {
                  left: `${parseInt(i.value) / (a ?? 10) * 100}%`,
                  scale: 0
                },
                whileInView: {
                  scale: 1
                },
                transition: {
                  delay: 0.25
                },
                exit: { scale: 0 }
              }
            ) }),
            /* @__PURE__ */ p("div", { className: o.scaleLabels, children: [
              /* @__PURE__ */ e("span", { className: o.scaleLabel, children: n("PDP_Size_Recommendation_Scale_Small") }),
              /* @__PURE__ */ e("span", { className: o.scaleLabel, children: n("PDP_Size_Recommendation_Scale_Perfect") }),
              /* @__PURE__ */ e("span", { className: o.scaleLabel, children: n("PDP_Size_Recommendation_Scale_Big") })
            ] })
          ] }),
          (s == null ? void 0 : s.value) && /* @__PURE__ */ e("span", { className: o.sizeText, children: s.value })
        ] });
    }
  )
), Ko = t.discriminatedUnion("template", [
  Gt
]), Ho = P(
  "SizeRecommendation",
  S(Ko, (a) => {
    if (a.template === "scale")
      return /* @__PURE__ */ e(Mo, { ...a });
  })
), Vo = t.object({
  variants: t.custom().optional(),
  template: t.enum(["button", "text"]).optional(),
  buttonVariants: Za.shape.variants.optional()
}), Uo = P(
  "ProductBundleUpsell",
  S(
    {
      schema: Vo,
      defaultProps: {
        template: "button",
        buttonVariants: {
          width: "full",
          color: "black",
          style: "outline"
        }
      }
    },
    ({ variants: a, buttonVariants: o, template: n }) => {
      const s = Be("bundle")[0], i = I(), c = va.styles(a);
      return s ? /* @__PURE__ */ e(
        ye,
        {
          productBase: s.product.base,
          className: c.base,
          children: n === "button" ? /* @__PURE__ */ e(
            rt,
            {
              label: i("PDP_Bundle_Upsell_Title", {
                // Add support for discount when it exists.
                name: s.product.base.content.name
              }),
              variants: o
            }
          ) : /* @__PURE__ */ e("span", { children: i("PDP_Bundle_Upsell_Title", {
            name: s.product.base.content.name
          }) })
        }
      ) : null;
    }
  )
), Wt = t.object({
  heading: t.string().optional(),
  subtitle: t.string().optional(),
  image: at.optional().nullable(),
  condition: t.string().optional(),
  variants: t.custom().optional()
}), $o = P(
  "ProductGiftWithPurchase",
  S(
    {
      schema: Wt,
      defaultProps: {
        image: {
          displaySize: "5vw"
        }
      }
    },
    ({ heading: a, subtitle: o, image: n, variants: s, condition: i }) => {
      var r;
      const c = ya.styles(s);
      return !a && !o && !n ? null : /* @__PURE__ */ p("div", { className: c.base, children: [
        /* @__PURE__ */ p("div", { className: c.contentWrapper, children: [
          n && ((r = n.image) == null ? void 0 : r.src) && /* @__PURE__ */ e(te, { ...n, className: c.image }),
          /* @__PURE__ */ p("div", { className: c.textWrapper, children: [
            a && /* @__PURE__ */ e("h3", { className: c.heading, children: a }),
            o && /* @__PURE__ */ e(nn, { content: o, className: c.subtitle })
          ] })
        ] }),
        i && /* @__PURE__ */ e("span", { className: c.condition, children: i })
      ] });
    }
  )
), Ot = t.object({
  template: t.literal("cairo"),
  variants: t.custom().optional(),
  content: t.custom()
}), Fo = P(
  "SizeGuideContent",
  S(Ot, ({ variants: a, content: o }) => {
    const n = Pa.styles(a);
    return /* @__PURE__ */ e(on.Provider, { value: !0, children: /* @__PURE__ */ e("div", { className: n.contentWrapper, children: o }) });
  })
), jt = t.object({
  template: t.literal("drawer"),
  contentSettings: Ot.optional(),
  drawerSettings: t.custom().optional(),
  enabled: t.boolean().optional(),
  applyButtonSettings: We.optional(),
  closeButtonSettings: We.optional()
}), Yo = "cairo", Xo = 1024, Qo = P(
  "SizeGuideDrawer",
  S(jt, (a) => {
    Sa.styles(), I();
    const o = a.contentSettings || {
      template: Yo
    };
    if (!a.enabled)
      return null;
    const [n, s] = $(!1);
    return U(() => {
      const i = () => {
        s(window.innerWidth > Xo);
      };
      return window.addEventListener("resize", i), i(), () => {
        window.removeEventListener("resize", i);
      };
    }, []), /* @__PURE__ */ e(
      j,
      {
        customOverlayId: "size-guide",
        hasOverlay: !0,
        hasScaledBackground: !0,
        setBackgroundColorOnScale: !1,
        hasHandle: !n,
        variants: {
          dragHandle: n ? "false" : "true",
          rounded: n ? "none" : "strong",
          background: "white",
          direction: n ? "right" : "bottom"
        },
        direction: n ? "right" : "bottom",
        ...a.drawerSettings,
        children: /* @__PURE__ */ e(j.Content, { children: /* @__PURE__ */ e(Fo, { ...o }) })
      }
    );
  })
), ze = t.discriminatedUnion("template", [
  jt
]), Zo = P(
  "SizeGuide",
  S(ze, (a) => {
    switch (a.template) {
      case "drawer":
        return /* @__PURE__ */ e(Qo, { ...a });
      default:
        return null;
    }
  })
), xe = t.object({
  link: Xa.optional(),
  label: t.string().optional(),
  icon: t.custom().optional(),
  variants: t.custom().optional()
}), qo = P(
  "SizeGuideTrigger",
  S(xe, ({ variants: a, label: o, link: n, icon: s }) => {
    const i = wa.styles(a);
    return /* @__PURE__ */ e(
      Qa,
      {
        onClick: () => ce.emit("open", { overlayId: "size-guide" }),
        className: i.trigger,
        label: o,
        icon: s,
        ...n
      }
    );
  })
), Jo = t.object({
  variants: t.custom().optional()
}), es = ({ variants: a }) => {
  const o = I(), n = _a.styles(a), s = Ae(), i = s.discountFromPriceOfItemsOutsideBundle.formatted, c = s.discountFromPriceOfItemsOutsideBundle.number;
  return !i || c <= 0 ? null : /* @__PURE__ */ p("div", { className: n.base, children: [
    /* @__PURE__ */ e("h3", { className: n.heading, children: o("PDP_Bundle_Promo_Banner_Heading", {
      bundleSavings: i
    }) }),
    /* @__PURE__ */ e("p", { className: n.text, children: o("PDP_Bundle_Promo_Banner_Text") })
  ] });
}, ts = P(
  "ProductBundlePromoBanner",
  S(
    {
      schema: Jo,
      defaultProps: {}
    },
    (a) => Z() !== "bundle" ? null : /* @__PURE__ */ e(es, { ...a })
  )
), m = {
  SizeGuide: Zo,
  Details: Ln,
  Root: gn,
  ImageGallery: Fn,
  AddToCart: uo,
  Specifications: Xn,
  Attributes: ao,
  SizePicker: vo,
  Siblings: No,
  RelatedProducts: Ao,
  StickyAddToCart: Lo,
  Bundle: zo,
  BundleUpsell: Uo,
  UspBlock: jo,
  SizeGuideTrigger: qo,
  SizeRecommendation: Ho,
  GiftWithPurchase: $o,
  BundlePromoBanner: ts,
  PriceHistoryDrawer: kn
  // Add other components as needed
}, Mt = t.object({
  template: t.literal("basic"),
  variants: t.custom().optional(),
  productTypeSettings: pe.optional(),
  productDesignerSettings: pe.optional(),
  relatedProductsSettings: ie.optional(),
  sizePickerSettings: Se.optional(),
  uspBlockSettings: me.optional(),
  siblingsPickerSettings: we.optional(),
  sizeGuideSettings: ze.optional(),
  sizeGuideTriggerSettings: xe.optional(),
  belowTheFoldComponents: t.custom().optional()
}), as = P(
  "ProductTemplateAsBasic",
  S(
    {
      schema: Mt,
      defaultProps: {
        template: "basic",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      sizePickerSettings: o,
      uspBlockSettings: n,
      siblingsPickerSettings: s,
      sizeGuideSettings: i,
      sizeGuideTriggerSettings: c,
      belowTheFoldComponents: r
    }) => {
      var g;
      const l = W(), u = ka.styles(), h = I();
      return /* @__PURE__ */ e(de, { mode: "wait", children: /* @__PURE__ */ p(
        J.section,
        {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          exit: { opacity: 0 },
          id: l.productId,
          className: u.base,
          children: [
            /* @__PURE__ */ e(
              se,
              {
                variants: { isOn: "pdp" },
                enableWrapper: !1,
                className: "block lg:hidden ml-3 mb-3"
              }
            ),
            /* @__PURE__ */ e(m.ImageGallery, { template: "keen", indicator: "number" }),
            /* @__PURE__ */ e(m.ImageGallery, { template: "grid" }),
            /* @__PURE__ */ p("section", { className: u.detailsWrapper, children: [
              /* @__PURE__ */ e(
                se,
                {
                  variants: { isOn: "pdp" },
                  enableWrapper: !1,
                  className: "hidden lg:block mb-4"
                }
              ),
              /* @__PURE__ */ e(m.Details.Brand, {}),
              /* @__PURE__ */ e(m.Details.Name, {}),
              /* @__PURE__ */ e(m.Details.Price, {}),
              /* @__PURE__ */ e(m.Attributes, { template: "tags", attributeKey: "sticker" }),
              /* @__PURE__ */ e(
                m.Siblings,
                {
                  template: "image-card",
                  ...s
                }
              ),
              /* @__PURE__ */ e(m.SizeGuide, { template: "drawer", ...i }),
              /* @__PURE__ */ e(
                m.SizePicker,
                {
                  template: "button-grid",
                  ...o,
                  headerContent: /* @__PURE__ */ e(
                    m.SizeGuideTrigger,
                    {
                      ...c,
                      label: h("Size_Guide_Trigger_Label")
                    }
                  )
                }
              ),
              /* @__PURE__ */ e(m.AddToCart, { template: "button" }),
              /* @__PURE__ */ e(m.UspBlock, { ...n }),
              /* @__PURE__ */ e(
                m.Attributes,
                {
                  label: h("PDP_Product_Features_Label"),
                  template: "icon-blocks",
                  attributeKey: "productFeatures"
                }
              )
            ] }),
            /* @__PURE__ */ p("div", { className: u.belowTheFoldDetails, children: [
              /* @__PURE__ */ e(
                m.Details.Description,
                {
                  label: h("PDP_Product_Description_Label")
                }
              ),
              /* @__PURE__ */ e(
                m.Details.Accordion,
                {
                  settings: {
                    radixAccordionSettings: {
                      root: {
                        type: "single",
                        collapsible: !0,
                        defaultValue: "details"
                      }
                    }
                  },
                  items: [
                    {
                      content: {
                        trigger: h("PDP_Product_Details"),
                        value: "details",
                        content: l.content.description
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Fabric_Care"),
                        attributeKey: "fabricCare_text"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_Material"),
                        attributeKey: "material"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_Manufacturer"),
                        attributeKey: "supplier"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_CareGuide"),
                        attributeKey: "care_guide"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_Manufacturer"),
                        attributeKey: "manufacturer"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_Shipping"),
                        attributeKey: "shipping"
                      }
                    }
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ e("div", { className: u.relatedProductsWrapper, children: /* @__PURE__ */ e(
              m.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(g = a == null ? void 0 : a.swiperSettings) == null ? void 0 : g.settings,
                    headerSettings: {
                      heading: {
                        heading: h("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) }),
            r
          ]
        }
      ) });
    }
  )
), Kt = t.object({
  template: t.literal("helsinki"),
  breadcrumbsSettings: sn.optional(),
  imageGallerySettings: wt.optional(),
  addToCartSettings: Dt.optional(),
  descriptionSettings: Ve.optional(),
  specificationSettings: kt.optional(),
  progressBarSettings: Fe.optional(),
  tagsSettings: t.array(Ye).optional(),
  relatedProductsSettings: ie.optional(),
  discontinuedBadgeWrapper: st.optional(),
  shippingBarometer: rn.optional(),
  id: t.string().optional()
}), ns = P(
  "ProductPageTemplateHelsinki",
  S(
    {
      schema: Kt,
      defaultProps: {
        template: "helsinki",
        breadcrumbsSettings: {
          variants: {
            isOn: "pdp"
          }
        },
        discontinuedBadgeWrapper: {
          rotate: "randomize"
          // variants: {
          //   color: "red",
          // },
        },
        imageGallerySettings: {
          template: "keen",
          indicator: "dots"
        },
        addToCartSettings: {
          template: "quantity-picker"
        },
        descriptionSettings: {
          readMoreSettings: {
            enabled: !0,
            limit: 160
          }
        },
        specificationSettings: {
          template: "table"
        },
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      breadcrumbsSettings: a,
      imageGallerySettings: o,
      addToCartSettings: n,
      descriptionSettings: s,
      specificationSettings: i,
      progressBarSettings: c,
      tagsSettings: r,
      relatedProductsSettings: l,
      discontinuedBadgeWrapper: u,
      shippingBarometer: h,
      id: g
    }) => {
      var b;
      const { status: v } = De(), _ = I(), w = Na.styles();
      return /* @__PURE__ */ p(
        "section",
        {
          id: g,
          className: "grid-cols-12 lg:grid-rows-[min-content_max-content] grid lg:gap-4 w-full lg:gap-y-12 bg-white lg:px-8 rounded-lg lg:max-h-[90vh] overflow-y-scroll",
          children: [
            /* @__PURE__ */ p(m.ImageGallery, { ...o, template: "keen", children: [
              /* @__PURE__ */ e(
                se,
                {
                  ...a,
                  layout: {
                    spacing: { applySpacing: "false" },
                    position: { applyPosition: "false" }
                  }
                }
              ),
              v === "discontinued" && /* @__PURE__ */ e("div", { className: w.discountinuedBadgeWrapper, children: /* @__PURE__ */ e(
                He,
                {
                  label: _("PDP_Discontinued_Badge"),
                  ...u
                }
              ) })
            ] }),
            /* @__PURE__ */ p("div", { className: w.addToCartWrapper, children: [
              /* @__PURE__ */ e(m.Details.Name, {}),
              v === "out-of-stock" && /* @__PURE__ */ p("div", { className: w.outOfStock, children: [
                /* @__PURE__ */ e("span", { className: w.outOfStockIndicator }),
                /* @__PURE__ */ e("span", { children: _("PDP_Out_Of_Stock") })
              ] }),
              v === "discontinued" && /* @__PURE__ */ p("div", { className: w.discontinued, children: [
                /* @__PURE__ */ e("span", { className: w.discontinuedIndicator }),
                /* @__PURE__ */ e("span", { children: _("PDP_Discontinued_Message") })
              ] }),
              v !== "discontinued" && /* @__PURE__ */ e(
                m.AddToCart,
                {
                  ...n ?? { template: "quantity-picker" }
                }
              ),
              /* @__PURE__ */ e(
                ln,
                {
                  ...h,
                  className: w.shippingBarometer
                }
              )
            ] }),
            /* @__PURE__ */ p("div", { className: w.detailsWrapper, children: [
              /* @__PURE__ */ e(m.Details.ShortDescription, {}),
              /* @__PURE__ */ e(m.Details.Description, { ...s }),
              /* @__PURE__ */ e(
                m.Specifications,
                {
                  ...i ?? { template: "table" }
                }
              )
            ] }),
            /* @__PURE__ */ p("div", { className: w.attributesWrapper, children: [
              /* @__PURE__ */ e(
                m.Attributes,
                {
                  template: "progress-bar",
                  ...c
                }
              ),
              r && /* @__PURE__ */ e("div", { className: w.tags, children: r.map((y, f) => /* @__PURE__ */ e(m.Attributes, { ...y }, f)) })
            ] }),
            /* @__PURE__ */ e("div", { className: w.relatedProductsWrapper, children: /* @__PURE__ */ e(
              m.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(b = l == null ? void 0 : l.swiperSettings) == null ? void 0 : b.settings,
                    headerSettings: {
                      heading: {
                        heading: _("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) })
          ]
        }
      );
    }
  )
), Ht = t.object({
  template: t.literal("malibu"),
  variants: t.custom().optional(),
  productTypeSettings: pe.optional(),
  relatedProductsSettings: ie.optional(),
  siblingSettings: Xe.optional(),
  sizePickerSettings: Se.optional(),
  uspBlockSettings: me.optional(),
  giftWithPurchaseSettings: Wt.optional(),
  extendAccordion: t.array(Ue).optional(),
  sizeGuideSettings: ze.optional(),
  sizeGuideTriggerSettings: xe.optional(),
  priceSettings: bt.optional(),
  priceCalloutSlot: t.custom().optional(),
  belowTheFoldComponents: t.custom().optional(),
  reviewComponentSlot: t.custom().optional(),
  sizeFinderSlot: t.custom().optional(),
  sizeFinderSlotPosition: t.enum(["above-atc", "below-atc"]).optional(),
  openFirstAccordionItem: t.boolean().optional(),
  alwaysShowStickyAddToCart: t.boolean().optional(),
  tagsComponentSlot: t.custom().optional(),
  bundleUpsell: t.custom().optional(),
  accordionRootSettings: t.custom().optional(),
  bundleDisplayStyle: t.enum(["card", "text"]).optional(),
  enableImageGalleryZoom: t.boolean().optional()
}), os = P(
  "ProductTemplateAsMalibu",
  S(
    {
      schema: Ht,
      defaultProps: {
        template: "malibu",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              itemsInView: {
                initial: "2.1",
                lg: "4.2",
                xl: "5"
              },
              variants: {
                layout: "stacked",
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      productTypeSettings: o,
      siblingSettings: n,
      sizePickerSettings: s,
      uspBlockSettings: i,
      extendAccordion: c,
      sizeGuideSettings: r,
      sizeGuideTriggerSettings: l,
      giftWithPurchaseSettings: u,
      priceSettings: h,
      priceCalloutSlot: g,
      belowTheFoldComponents: v,
      reviewComponentSlot: _,
      accordionRootSettings: w,
      sizeFinderSlot: b,
      bundleUpsell: y,
      sizeFinderSlotPosition: f,
      tagsComponentSlot: L,
      openFirstAccordionItem: T,
      alwaysShowStickyAddToCart: x,
      bundleDisplayStyle: A,
      enableImageGalleryZoom: E
    }) => {
      var Y;
      const H = W(), d = Ta.styles(), z = I(), R = K("fit_text", t.string()), [O, F] = $(
        void 0
      );
      return U(() => {
        const V = () => F("reviews");
        return window.addEventListener("pdp:open-reviews", V), () => window.removeEventListener("pdp:open-reviews", V);
      }, []), /* @__PURE__ */ p("section", { className: d.base, children: [
        /* @__PURE__ */ e(dt, { template: "drawer" }),
        /* @__PURE__ */ e(
          m.ImageGallery,
          {
            template: "keen",
            indicator: "dots",
            zoom: E
          }
        ),
        /* @__PURE__ */ e(
          m.StickyAddToCart,
          {
            template: "button",
            mode: x ? "isNotVisible" : "isScrolledPast"
          }
        ),
        /* @__PURE__ */ e(m.ImageGallery, { template: "grid", zoom: E }),
        /* @__PURE__ */ p("section", { className: d.detailsWrapper, children: [
          /* @__PURE__ */ e(
            se,
            {
              enableWrapper: !1,
              variants: { isOn: "pdp" },
              layout: {
                spacing: { applySpacing: "false" },
                position: { applyPosition: "false" }
              }
            }
          ),
          /* @__PURE__ */ e(m.Details.Name, {}),
          /* @__PURE__ */ e(
            m.Details.Price,
            {
              ...h,
              priceHistoryDrawerSettings: {
                isEnabled: !0,
                trigger: /* @__PURE__ */ e(cn, { className: "w-3 h-3 lg:w-4 lg:h-4 fill-[#71717a]" })
              }
            }
          ),
          /* @__PURE__ */ e(m.Details.ProductType, { ...o }),
          g,
          _,
          L,
          /* @__PURE__ */ e(m.Siblings, { template: "image-card", ...n }),
          /* @__PURE__ */ e(
            m.SizePicker,
            {
              template: "button-grid",
              ...s
            }
          ),
          /* @__PURE__ */ e(m.BundlePromoBanner, {}),
          /* @__PURE__ */ e(m.Bundle, {}),
          f !== "below-atc" && b && b,
          /* @__PURE__ */ e(
            m.AddToCart,
            {
              template: "button",
              isNotifyMeEnabled: (Y = s == null ? void 0 : s.notifyMe) == null ? void 0 : Y.enabled
            }
          ),
          f === "below-atc" && b && b,
          A === "text" && /* @__PURE__ */ e(m.BundleUpsell, {}),
          (R == null ? void 0 : R.value) && /* @__PURE__ */ e("span", { className: d.fitText, children: R.value }),
          /* @__PURE__ */ e(m.SizeRecommendation, { template: "scale" }),
          (r == null ? void 0 : r.enabled) && /* @__PURE__ */ e(
            m.SizeGuideTrigger,
            {
              ...l,
              label: z("Size_Guide_Trigger_Label")
            }
          ),
          /* @__PURE__ */ e(m.SizeGuide, { template: "drawer", ...r }),
          /* @__PURE__ */ e(m.UspBlock, { ...i }),
          /* @__PURE__ */ e(m.GiftWithPurchase, { ...u }),
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "icon-blocks",
              attributeKey: "productFeaturesVariant"
            }
          ),
          /* @__PURE__ */ e(
            m.Details.Accordion,
            {
              items: [
                {
                  content: {
                    trigger: z("PDP_Product_Description"),
                    value: "description",
                    forceMount: !0,
                    content: H.content.description
                  }
                },
                {
                  content: {
                    trigger: z("PDP_Fabric_Care"),
                    attributeKey: "fabricCare_text",
                    forceMount: !0
                  }
                },
                {
                  content: {
                    trigger: z("PDP_Product_Details"),
                    forceMount: !0,
                    content: H.content.shortDescription
                  }
                },
                ...c ?? []
              ],
              settings: {
                radixAccordionSettings: {
                  root: w ?? {
                    type: "single",
                    value: O,
                    defaultValue: T ? "description" : void 0,
                    onValueChange: (V) => F(V)
                  }
                }
              }
            }
          ),
          A === "card" && y
        ] }),
        v
      ] });
    }
  )
), Vt = t.object({
  template: t.literal("vienna"),
  variants: t.custom().optional(),
  relatedProductsSettings: ie.optional(),
  sizePickerSettings: ve.optional(),
  sizePicker2Settings: ve.optional(),
  uspBlockSettings: me.optional(),
  imageGallerySettings: Le.optional(),
  siblingsPickerSettings: we.optional(),
  reviewCarouselComponent: t.custom().optional(),
  reviewStarsComponent: t.custom().optional(),
  detailsComponentSlot: t.custom().optional(),
  sizeGuideComponentSlot: t.custom().optional(),
  beforeSiblingsSlot: t.custom().optional(),
  afterSiblingsSlot: t.custom().optional(),
  belowTheFoldComponents: t.custom().optional(),
  afterAddToCartSlot: t.custom().optional(),
  afterAttributesSlot: t.custom().optional(),
  washingInstructionDrawer: t.custom().optional()
}), ss = () => /* @__PURE__ */ e(m.AddToCart, { template: "button" }), is = ({
  sizePickerSettings: a,
  sizePicker2Settings: o
}) => {
  const n = I(), s = xa();
  return /* @__PURE__ */ e(Q, { children: s ? /* @__PURE__ */ p(Q, { children: [
    /* @__PURE__ */ e(m.SizePicker, { ...a, template: "modal" }),
    /* @__PURE__ */ e(
      m.SizePicker,
      {
        ...o,
        template: "modal",
        triggerLabel: n("PDP_Add_To_Cart"),
        customOverlayId: "size-picker-modal-2"
      }
    )
  ] }) : /* @__PURE__ */ e(
    fe,
    {
      label: n("PDP_Out_Of_Stock"),
      disabled: !0,
      "aria-disabled": "true",
      variants: {
        width: "full"
      }
    }
  ) });
}, rs = P(
  "ProductTemplateAsVienna",
  S(
    {
      schema: Vt,
      defaultProps: {
        template: "vienna",
        sizePickerSettings: {
          template: "modal",
          buttonVariants: {
            color: "black",
            style: "outline",
            width: "full"
          }
        },
        sizePicker2Settings: {
          template: "modal",
          buttonVariants: {
            style: "solid",
            width: "full"
          }
        },
        relatedProductsSettings: {
          template: "image-cards"
        }
      }
    },
    ({
      relatedProductsSettings: a,
      sizePickerSettings: o,
      sizePicker2Settings: n,
      uspBlockSettings: s,
      imageGallerySettings: i,
      siblingsPickerSettings: c,
      detailsComponentSlot: r,
      reviewStarsComponent: l,
      sizeGuideComponentSlot: u,
      beforeSiblingsSlot: h,
      afterSiblingsSlot: g,
      belowTheFoldComponents: v,
      washingInstructionDrawer: _,
      afterAddToCartSlot: w,
      afterAttributesSlot: b
    }) => {
      var z, R, O, F, Y, V;
      const y = W(), f = Ca.styles(), L = I(), T = Z(), x = (z = K(
        "product_highlight_text",
        t.string()
      )) == null ? void 0 : z.value, A = (R = K(
        "pr_video_url",
        t.string()
      )) == null ? void 0 : R.value, E = (O = K("pr_badge", t.string().array())) == null ? void 0 : O.value, H = (F = K(
        "washing_advice_text",
        t.string()
      )) == null ? void 0 : F.value, d = T === "simple";
      return /* @__PURE__ */ p("section", { className: f.base, children: [
        /* @__PURE__ */ e("div", { className: f.breadcrumbsWrapper, children: /* @__PURE__ */ e(
          se,
          {
            layout: {
              spacing: { applySpacing: "false" },
              position: { applyPosition: "false" }
            }
          }
        ) }),
        /* @__PURE__ */ e(
          m.ImageGallery,
          {
            template: "keen",
            indicator: "dots",
            buttonInSlider: {
              enabled: !!(A && (A == null ? void 0 : A.length) > 0),
              onClick: () => {
                const C = document == null ? void 0 : document.getElementById("youtube-video");
                C && C.scrollIntoView({ behavior: "smooth" });
              },
              label: L("Product_Video_Button_Text")
            },
            ...i,
            children: /* @__PURE__ */ e("div", { className: f.badgesWrapper, children: E == null ? void 0 : E.map((C, D) => /* @__PURE__ */ e(He, { label: C }, D)) })
          }
        ),
        /* @__PURE__ */ p("section", { className: f.detailsWrapper, children: [
          /* @__PURE__ */ p("div", { className: "flex flex-row justify-between items-center lg:mt-0 mb-2", children: [
            /* @__PURE__ */ p("div", { className: "flex items-center empty:hidden flex-wrap", children: [
              /* @__PURE__ */ e(m.Details.ProductType, { attributeKey: "wiring" }),
              ((Y = K("wiring", t.string())) == null ? void 0 : Y.value) && ((V = K("padding", t.string())) == null ? void 0 : V.value) && /* @__PURE__ */ e("span", { className: "m-1 mb-2", children: "•" }),
              /* @__PURE__ */ e(m.Details.ProductType, { attributeKey: "padding" })
            ] }),
            l
          ] }),
          /* @__PURE__ */ e(m.Details.Name, {}),
          /* @__PURE__ */ e(m.Details.Price, {}),
          h,
          /* @__PURE__ */ e(
            m.Siblings,
            {
              template: "color-swatch",
              ...c
            }
          ),
          g,
          /* @__PURE__ */ p("div", { className: "flex flex-col gap-2", children: [
            u,
            /* @__PURE__ */ e(
              "div",
              {
                className: "w-full flex flex-row gap-4",
                id: "add-to-cart-component",
                children: d ? /* @__PURE__ */ e(ss, {}) : /* @__PURE__ */ e(
                  is,
                  {
                    sizePicker2Settings: n,
                    sizePickerSettings: o
                  }
                )
              }
            ),
            w
          ] }),
          /* @__PURE__ */ e(m.UspBlock, { ...s }),
          /* @__PURE__ */ e(
            m.StickyAddToCart,
            {
              template: "button",
              mode: "isNotVisible",
              selectSizeAction: "open-size-picker",
              withSizePicker: !0
            }
          )
        ] }),
        /* @__PURE__ */ e(m.Details.Description, {}),
        x && /* @__PURE__ */ e("ul", { className: f.highlightTextWrapper, children: x == null ? void 0 : x.split(";").map((C, D) => /* @__PURE__ */ e("li", { className: f.highlightTextRow, children: C }, D)) }),
        /* @__PURE__ */ p("section", { className: f.attributesWrapper, children: [
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "row",
              attributeKey: "material_pdp_text"
            }
          ),
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "row",
              data: {
                attributeLabel: L("washing_advice_text"),
                value: /* @__PURE__ */ p(Q, { children: [
                  H,
                  " ",
                  _
                ] })
              }
            }
          ),
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "row",
              attributeKey: "product_key",
              data: {
                attributeLabel: L("Article_Number"),
                value: y.productKey
              }
            }
          ),
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "row",
              attributeKey: "hooks_and_eye_text"
            }
          )
        ] }),
        b,
        A && /* @__PURE__ */ e("div", { className: f.productVideo, id: "youtube-video", children: /* @__PURE__ */ e(
          "div",
          {
            className: "relative w-full",
            style: { paddingBottom: "56.25%" },
            children: /* @__PURE__ */ e(
              "iframe",
              {
                className: "absolute top-0 left-0 w-full h-full",
                src: A.includes("youtube.com/watch?v=") ? `https://www.youtube.com/embed/${A.split("v=")[1]}` : A,
                title: "Product video",
                frameBorder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowFullScreen: !0
              }
            )
          }
        ) }),
        /* @__PURE__ */ e(
          m.RelatedProducts,
          {
            template: "image-cards",
            relationType: "standard",
            ...a
          }
        ),
        r,
        v
      ] });
    }
  )
), Ut = t.object({
  template: t.literal("graz"),
  variants: t.custom().optional(),
  productTypeSettings: pe.optional(),
  productDesignerSettings: pe.extend({
    link: t.string().optional()
  }).optional(),
  relatedProductsSettings: ie.optional(),
  sizePickerSettings: Se.optional(),
  uspBlockSettings: me.optional(),
  siblingsPickerSettings: we.optional(),
  sizeGuideSettings: ze.optional(),
  sizeGuideTriggerSettings: xe.optional(),
  productSku: t.string().optional(),
  ecomidNudgeSlot: t.custom().optional(),
  belowTheFoldComponents: t.custom().optional(),
  reviewComponentSlot: t.custom().optional(),
  extendAccordion: t.array(Ue).optional(),
  accordionRootSettings: t.custom().optional()
}), ls = P(
  "ProductTemplateAsGraz",
  S(
    {
      schema: Ut,
      defaultProps: {
        template: "graz",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      productTypeSettings: o,
      productDesignerSettings: n,
      sizePickerSettings: s,
      uspBlockSettings: i,
      siblingsPickerSettings: c,
      sizeGuideSettings: r,
      sizeGuideTriggerSettings: l,
      ecomidNudgeSlot: u,
      belowTheFoldComponents: h,
      productSku: g,
      reviewComponentSlot: v,
      extendAccordion: _,
      accordionRootSettings: w
    }) => {
      var A, E, H;
      const b = W(), y = Aa.styles(), f = I(), L = dn(), [T, x] = $(
        void 0
      );
      return U(() => {
        const d = () => {
          x("reviews"), setTimeout(() => {
            const z = document.getElementById("testfreaks-reviews"), R = z == null ? void 0 : z.closest('[role="region"]'), O = (R == null ? void 0 : R.parentElement) ?? z;
            O == null || O.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 50);
        };
        return window.addEventListener("pdp:open-reviews", d), () => window.removeEventListener("pdp:open-reviews", d);
      }, []), /* @__PURE__ */ e(de, { mode: "wait", children: /* @__PURE__ */ p(
        J.section,
        {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          exit: { opacity: 0 },
          id: b.productId,
          className: y.base,
          children: [
            /* @__PURE__ */ e(dt, { template: "drawer" }),
            /* @__PURE__ */ e(
              se,
              {
                variants: { isOn: "pdp" },
                enableWrapper: !1,
                className: "block lg:hidden"
              }
            ),
            /* @__PURE__ */ e(m.ImageGallery, { template: "keen", indicator: "dots" }),
            /* @__PURE__ */ e(m.StickyAddToCart, { template: "button", mode: "isNotVisible" }),
            /* @__PURE__ */ e(m.ImageGallery, { template: "grid" }),
            /* @__PURE__ */ p("section", { className: y.detailsWrapper, children: [
              /* @__PURE__ */ e(
                se,
                {
                  variants: { isOn: "pdp" },
                  enableWrapper: !1,
                  className: "hidden lg:block"
                }
              ),
              /* @__PURE__ */ p("div", { className: y.tagsWrapper, children: [
                /* @__PURE__ */ e(m.Details.ProductType, { ...o }),
                /* @__PURE__ */ e(L, { href: (n == null ? void 0 : n.link) ?? "", children: /* @__PURE__ */ e(m.Details.ProductType, { ...n }) })
              ] }),
              /* @__PURE__ */ e(m.Details.Name, {}),
              /* @__PURE__ */ e(m.Details.Price, {}),
              /* @__PURE__ */ e(m.Attributes, { template: "tags", attributeKey: "sticker" }),
              v ? /* @__PURE__ */ e("div", { className: "col-span-full lg:col-start-3 lg:col-end-4 lg:row-start-3 lg:justify-self-end empty:hidden", children: v }) : null,
              /* @__PURE__ */ e(
                m.Siblings,
                {
                  template: "color-swatch",
                  ...c
                }
              ),
              /* @__PURE__ */ e(m.SizeGuide, { template: "drawer", ...r }),
              /* @__PURE__ */ e(
                m.SizePicker,
                {
                  template: "button-grid",
                  ...s,
                  headerContent: /* @__PURE__ */ e(
                    m.SizeGuideTrigger,
                    {
                      ...l,
                      label: f("Size_Guide_Trigger_Label")
                    }
                  )
                }
              ),
              /* @__PURE__ */ e(
                m.AddToCart,
                {
                  template: "button",
                  isNotifyMeEnabled: (A = s == null ? void 0 : s.notifyMe) == null ? void 0 : A.enabled
                }
              ),
              /* @__PURE__ */ e(m.UspBlock, { ...i }),
              /* @__PURE__ */ e("div", { className: y.retracedIcons, children: /* @__PURE__ */ e("retraced-icons", {}) }),
              /* @__PURE__ */ e(
                m.Attributes,
                {
                  label: f("PDP_Product_Features_Label"),
                  template: "icon-blocks",
                  attributeKey: "productFeatures"
                }
              ),
              /* @__PURE__ */ e(
                m.Details.Accordion,
                {
                  settings: {
                    radixAccordionSettings: {
                      root: w ?? {
                        type: "single",
                        collapsible: !0,
                        value: T,
                        onValueChange: (d) => x(d)
                      }
                    }
                  },
                  items: [
                    {
                      content: {
                        forceMount: !0,
                        trigger: f("PDP_Product_Details"),
                        content: b.content.description
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: f("PDP_Fabric_Care"),
                        attributeKey: "fabricCare_text"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: f("PDP_Product_Material"),
                        attributeKey: "pr_fabric"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: f("PDP_Product_Manufacturer"),
                        attributeKey: "supplier"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: f("PDP_Product_CareGuide"),
                        attributeKey: "care_guide"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: f("PDP_Product_Manufacturer"),
                        attributeKey: "manufacturer"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: f("PDP_Product_Shipping"),
                        attributeKey: "shipping"
                      }
                    },
                    ..._ ?? []
                  ]
                }
              ),
              /* @__PURE__ */ e(
                m.Attributes,
                {
                  label: f("PDP_Product_Certifications"),
                  template: "icon-blocks",
                  attributeKey: "certifications"
                }
              ),
              u,
              /* @__PURE__ */ e("span", { className: y.productId, children: f("PDP_Product_Id", {
                productId: b.productId,
                sku: g || ""
              }) })
            ] }),
            /* @__PURE__ */ e("div", { className: y.relatedProductsWrapper, children: /* @__PURE__ */ e(
              m.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(E = a == null ? void 0 : a.swiperSettings) == null ? void 0 : E.settings,
                    headerSettings: {
                      heading: {
                        heading: f("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) }),
            h,
            /* @__PURE__ */ e("div", { className: y.relatedProductsWrapper, children: /* @__PURE__ */ e(
              m.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(H = a == null ? void 0 : a.swiperSettings) == null ? void 0 : H.settings,
                    headerSettings: {
                      heading: {
                        heading: f("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) })
          ]
        }
      ) });
    }
  )
), $t = t.object({
  template: t.literal("salzburg"),
  variants: t.custom().optional(),
  relatedProductsSettings: ie.optional(),
  sizePickerSettings: ve.optional(),
  uspBlockSettings: me.optional(),
  siblingsPickerSettings: we.optional(),
  imageGallerySettings: Le.optional(),
  descriptionSettings: Ve.optional(),
  nameSettings: mt.optional(),
  customSiblings: t.custom().optional()
}), cs = P(
  "ProductTemplateAsSalzburg",
  S(
    {
      schema: $t,
      defaultProps: {
        template: "salzburg",
        relatedProductsSettings: {
          template: "image-cards"
        }
      }
    },
    ({
      sizePickerSettings: a,
      imageGallerySettings: o,
      nameSettings: n,
      descriptionSettings: s,
      siblingsPickerSettings: i,
      variants: c,
      customSiblings: r
    }) => {
      const l = ge.main.styles(c), u = I();
      return /* @__PURE__ */ p("section", { className: l.base, children: [
        /* @__PURE__ */ p("section", { className: l.detailsWrapper, children: [
          /* @__PURE__ */ e(
            m.Details.Name,
            {
              ...n,
              blueprint: ge.details
            }
          ),
          /* @__PURE__ */ e(
            m.Details.Description,
            {
              ...s,
              blueprint: ge.details
            }
          ),
          r || /* @__PURE__ */ e(
            m.Siblings,
            {
              template: "color-swatch",
              ...i
            }
          ),
          /* @__PURE__ */ p("div", { className: "w-full flex flex-col lg:flex-row gap-3 lg:gap-4 justify-between", children: [
            /* @__PURE__ */ e(
              m.Details.Price,
              {
                blueprint: ge.details
              }
            ),
            /* @__PURE__ */ e(
              m.SizePicker,
              {
                template: "modal",
                ...a,
                triggerLabel: "PDP_Add_To_Cart"
              }
            )
          ] }),
          /* @__PURE__ */ e("span", { className: l.returnPolicyWrapper, children: u("Product_Return_Policy") })
        ] }),
        /* @__PURE__ */ e(
          m.ImageGallery,
          {
            template: "keen",
            indicator: "dots",
            blueprint: ge.gallery,
            ...o
          }
        )
      ] });
    }
  )
), Ft = t.object({
  template: t.literal("linz"),
  variants: t.custom().optional()
}), ds = P(
  "ProductTemplateAsLinz",
  S(Ft, () => /* @__PURE__ */ p(m.Root, { template: "grid", children: [
    /* @__PURE__ */ e(
      m.ImageGallery,
      {
        template: "keen",
        indicator: "number",
        slidesPerView: { mobile: 1, tablet: 1, desktop: 3 },
        gap: { mobile: 0, tablet: 0, desktop: 0 }
      }
    ),
    /* @__PURE__ */ p("div", { className: "col-span-12 lg:col-start-9 lg:col-end-13 top-0 left-0 row-start-1 row-end-2 flex flex-col p-4 bg-[#aeaeae7d] backdrop-blur-lg rounded-lg sticky right-6 place-self-end w-full order-2 h-fit lg:self-end lg:p-6", children: [
      /* @__PURE__ */ e(m.Details.Name, {}),
      /* @__PURE__ */ e(m.Details.Price, {}),
      /* @__PURE__ */ e(m.Siblings, { template: "image-card" }),
      /* @__PURE__ */ e(m.SizePicker, { template: "button-grid" }),
      /* @__PURE__ */ e(m.AddToCart, { template: "button" })
    ] })
  ] }))
), us = t.discriminatedUnion("template", [
  Mt,
  Kt,
  Ht,
  Vt,
  Ut,
  $t,
  Ft
]), Zs = P(
  "ProductTemplate",
  S(us, (a) => a.template === "basic" ? /* @__PURE__ */ e(as, { ...a }) : a.template === "helsinki" ? /* @__PURE__ */ e(ns, { ...a }) : a.template === "malibu" ? /* @__PURE__ */ e(os, { ...a }) : a.template === "vienna" ? /* @__PURE__ */ e(rs, { ...a }) : a.template === "graz" ? /* @__PURE__ */ e(ls, { ...a }) : a.template === "salzburg" ? /* @__PURE__ */ e(cs, { ...a }) : a.template === "linz" ? /* @__PURE__ */ e(ds, { ...a }) : null)
), qs = (a) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...a,
    children: /* @__PURE__ */ e(
      "path",
      {
        stroke: "#18181B",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m13.5999 4-7.7 7.7-3.5-3.5"
      }
    )
  }
);
export {
  In as Accordion,
  uo as AddToCart,
  co as AddToCartButton,
  io as AddToCartQuanityPickerRow,
  ro as AddToCartQuantityPicker,
  ao as Attributes,
  Jn as AttributesAsIconBlocks,
  Zn as AttributesAsProgressBar,
  eo as AttributesAsRow,
  qn as AttributesAsTags,
  to as AttributesPropsSchema,
  Qs as AttributesTagsItemSchema,
  as as Basic,
  wn as Brand,
  Sn as BrandSchema,
  zo as Bundle,
  ts as BundlePromoBanner,
  gt as BundleSavingsBadge,
  Uo as BundleUpsell,
  qs as Checkmark,
  un as CrossSvg,
  Pn as Description,
  Ln as Details,
  vt as FULL_VIEWPORT_DISPLAY_SIZE,
  $o as GiftWithPurchase,
  ls as Graz,
  ns as Helsinki,
  no as IconMinus,
  oo as IconPlus,
  Fn as ImageGallery,
  Un as ImageGalleryAsGrid,
  Hn as ImageGalleryAsKeen,
  ds as Linz,
  os as Malibu,
  fn as Name,
  Nn as Price,
  kn as PriceHistoryDrawer,
  bt as PriceSchema,
  m as Product,
  Zs as ProductTemplate,
  us as ProductTemplatePropsSchema,
  Bn as ProductType,
  Ao as RelatedProducts,
  xt as RelatedProductsImageCards,
  Co as RelatedProductsSwiper,
  gn as Root,
  mn as RootAsDrawer,
  pn as RootAsDrawerDialog,
  ut as RootAsDrawerSchema,
  hn as RootAsGrid,
  pt as RootAsGridSchema,
  bn as RootPropsSchema,
  $e as SHOP_THE_LOOK_ATTRIBUTE_KEY,
  At as STATUS_TRANSLATIONS,
  cs as Salzburg,
  ft as ShopTheLook,
  En as ShopTheLookItem,
  yn as ShortDescription,
  vn as ShortDescriptionSchema,
  ko as SiblingColorSwatchList,
  No as Siblings,
  yo as SiblingsImageCard,
  Zo as SizeGuide,
  Fo as SizeGuideContent,
  Qo as SizeGuideDrawer,
  qo as SizeGuideTrigger,
  vo as SizePicker,
  po as SizePickerButtonGrid,
  go as SizePickerModal,
  Ho as SizeRecommendation,
  Mo as SizeRecommendationScale,
  Xn as Specifications,
  Yn as SpecificationsAsTable,
  _t as SpecificationsAsTableSchema,
  Lo as StickyAddToCart,
  Do as StickyAddToCartButton,
  It as Swatch,
  jo as UspBlock,
  rs as Vienna,
  An as Wrapper,
  Cn as WrapperSchema,
  Pt as ZoomCursorOverlay,
  Ue as accordionItemSchema,
  Dn as accordionSchema,
  Bt as addToCartButtonSchema,
  Ct as addToCartQuantityPickerSchema,
  Dt as addToCartSchema,
  Nt as attributesAsIconBlocksSchema,
  Fe as attributesAsProgressBarSchema,
  Tt as attributesAsRowSchema,
  Ye as attributesAsTagsSchema,
  Qn as attributesProgressBarItemSchema,
  zn as bundleSavingsBadgeSchema,
  Ve as descriptionSchema,
  Wt as giftWithPurchaseSchema,
  St as imageGalleryAsGridSchema,
  Le as imageGalleryAsKeenSchema,
  wt as imageGalleryPropsSchema,
  mt as nameSchema,
  ht as priceHistoryDrawerSchema,
  Gt as productSizeRecommendationScaleSchema,
  Mt as productTemplateAsBasicSchema,
  Ut as productTemplateAsGrazSchema,
  Kt as productTemplateAsHelsinkiSchema,
  Ft as productTemplateAsLinzSchema,
  Ht as productTemplateAsMalibuSchema,
  $t as productTemplateAsSalzburgSchema,
  Vt as productTemplateAsViennaSchema,
  pe as productTypeSchema,
  zt as relatedProductsImageCardsSchema,
  ie as relatedProductsSchema,
  Rt as relatedProductsSwiperSchema,
  Rn as shopTheLookItemSchema,
  Gn as shopTheLookSchema,
  Lt as siblingColorSwatchListSchema,
  Xe as siblingsImageCardSchema,
  we as siblingsSchema,
  Ot as sizeGuideContentSchema,
  jt as sizeGuideDrawerSchema,
  ze as sizeGuideSchema,
  xe as sizeGuideTriggerSchema,
  Se as sizePickerButtonGridSchema,
  ve as sizePickerModalSchema,
  fo as sizePickerSchema,
  Ko as sizeRecommendationSchema,
  kt as specificationsPropsSchema,
  Et as stickyAddToCartButtonSchema,
  Io as stickyaddToCartSchema,
  lo as useAddToCartLabel,
  Bo as useElementVisibility,
  yt as useImageZoom,
  me as uspBlockSchema
};
//# sourceMappingURL=index.es.js.map
